export default {
  "id": 295310144,
  "property_type": "Land",
  "property_sub_type": "Type 1",
  "property_universal_id": null,
  "dash_guid": null,
  "dash_deactivated_at": null,
  "source": "User",
  "created_at": "2021-09-20T23:16:45.322Z",
  "updated_at": "2022-02-04T14:58:26.062Z",
  "private": false,
  "hide_photos": false,
  "board_id": null,
  "property_id": null,
  "user_id": 1011665,
  "custom_fields": {},
  "characteristics": {
  "anchors_co_tenants": null,
    "community_features": null,
    "current_use": null,
    "development_status": null,
    "fencing": null,
    "frontage_length": null,
    "frontage_type": null,
    "furnished": null,
    "furnished_y_n": null,
    "horse_amenities": null,
    "horse_y_n": null,
    "land_lease_amount": null,
    "land_lease_amount_frequency": null,
    "land_lease_expiration_date": null,
    "land_lease_y_n": null,
    "laundry_features": null,
    "lease_term": "6 Months",
    "lot_dimensions_source": null,
    "lot_features": null,
    "lot_size_acres": null,
    "lot_size_area": "10.0",
    "lot_size_dimensions": null,
    "lot_size_source": null,
    "lot_size_square_feet": null,
    "lot_size_units": "Acres",
    "mobile_home_remains_y_n": null,
    "number_of_buildings": null,
    "number_of_lots": null,
    "number_of_pads": null,
    "number_of_units_in_community": null,
    "number_of_units_total": null,
    "park_manager_name": null,
    "park_manager_phone": null,
    "park_name": null,
    "pool_features": null,
    "pool_private_y_n": null,
    "possible_use": null,
    "road_frontage_type": null,
    "road_responsibility": null,
    "road_surface_type": null,
    "senior_community_y_n": null,
    "spa_features": null,
    "spa_y_n": null,
    "topography": null,
    "units_furnished": null,
    "view": "View 1",
    "view_y_n": null,
    "water_body_name": null,
    "waterfront_features": null,
    "waterfront_y_n": null
},
  "meta": [],
  "board": null,
  "business": {
  "business_name": null,
    "business_type": null,
    "hours_days_of_operation_description": null,
    "hours_days_of_operation": null,
    "labor_information": null,
    "lease_amount": null,
    "lease_amount_frequency": null,
    "lease_assignable_y_n": null,
    "lease_expiration": null,
    "lease_renewal_option_y_n": null,
    "number_of_full_time_employees": null,
    "number_of_part_time_employees": null,
    "ownership_type": null,
    "seating_capacity": null,
    "special_licenses": null,
    "year_established": null,
    "years_current_owner": null
},
  "equipment": {
  "appliances": null,
    "other_equipment": null,
    "security_features": null
},
  "farming": {
  "crops_included_y_n": null,
    "cultivated_area": null,
    "farm_credit_service_incl_y_n": null,
    "farm_land_area_source": null,
    "farm_land_area_units": null,
    "grazing_permits_blm_y_n": null,
    "grazing_permits_forest_service_y_n": null,
    "grazing_permits_private_y_n": null,
    "pasture_area": null,
    "range_area": null,
    "vegetation": null,
    "wooded_area": null
},
  "financial": {
  "cable_tv_expense": null,
    "cap_rate": null,
    "electric_expense": null,
    "existing_lease_type": null,
    "financial_data_source": null,
    "fuel_expense": null,
    "furniture_replacement_expense": null,
    "gardener_expense": null,
    "gross_income": null,
    "gross_scheduled_income": null,
    "income_includes": null,
    "insurance_expense": null,
    "licenses_expense": null,
    "maintenance_expense": null,
    "manager_expense": null,
    "net_operating_income": null,
    "new_taxes_expense": null,
    "number_of_units_leased": null,
    "number_of_units_mo_mo": null,
    "number_of_units_vacant": null,
    "operating_expense": null,
    "operating_expense_includes": null,
    "other_expense": null,
    "owner_pays": null,
    "pest_control_expense": null,
    "pool_expense": null,
    "professional_management_expense": null,
    "rent_control_y_n": null,
    "rent_includes": null,
    "security_deposit": null,
    "supplies_expense": null,
    "tenant_pays": null,
    "total_actual_rent": null,
    "trash_expense": null,
    "vacancy_allowance": null,
    "vacancy_allowance_rate": null,
    "water_sewer_expense": null,
    "workmans_compensation_expense": null
},
  "hoa": {
  "association_amenities": null,
    "association_fee_2": null,
    "association_fee_2_frequency": null,
    "association_fee": null,
    "association_fee_frequency": null,
    "association_fee_includes": null,
    "association_name_2": null,
    "association_name": null,
    "association_phone_2": null,
    "association_phone": null,
    "association_y_n": null,
    "pets_allowed": null
},
  "listing": {
  "copyright_notice": null,
    "disclaimer": null,
    "home_warranty_y_n": null,
    "lease_considered_y_n": null,
    "list_aor": null,
    "listing_agreement": null,
    "listing_id": null,
    "listing_key": null,
    "listing_key_numeric": null,
    "listing_service": null,
    "listing_type": "Type One",
    "mls_status": "Sold",
    "originating_system_id": null,
    "originating_system_key": null,
    "originating_system_name": null,
    "source_system_id": null,
    "source_system_key": null,
    "source_system_name": null,
    "standard_status": null,
    "agent_office": {
    "buyer_agent": {
      "user_id": null,
        "buyer_agent_aor": null,
        "buyer_agent_designation": null,
        "buyer_agent_direct_phone": null,
        "buyer_agent_email": null,
        "buyer_agent_fax": null,
        "buyer_agent_first_name": null,
        "buyer_agent_full_name": null,
        "buyer_agent_home_phone": null,
        "buyer_agent_key": null,
        "buyer_agent_key_numeric": null,
        "buyer_agent_last_name": null,
        "buyer_agent_middle_name": null,
        "buyer_agent_mls_id": null,
        "buyer_agent_mobile_phone": null,
        "buyer_agent_name_prefix": null,
        "buyer_agent_name_suffix": null,
        "buyer_agent_office_phone_ext": null,
        "buyer_agent_office_phone": null,
        "buyer_agent_pager": null,
        "buyer_agent_preferred_phone_ext": null,
        "buyer_agent_preferred_phone": null,
        "buyer_agent_state_license": null,
        "buyer_agent_toll_free_phone": null,
        "buyer_agent_url": null,
        "buyer_agent_voice_mail_ext": null,
        "buyer_agent_voice_mail": null
    },
    "buyer_office": {
      "buyer_office_aor": null,
        "buyer_office_email": null,
        "buyer_office_fax": null,
        "buyer_office_key": null,
        "buyer_office_key_numeric": null,
        "buyer_office_mls_id": null,
        "buyer_office_name": null,
        "buyer_office_phone_ext": null,
        "buyer_office_phone": null,
        "buyer_office_url": null,
        "office": null
    },
    "co_buyer_agent": {
      "user_id": null,
        "co_buyer_agent_aor": null,
        "co_buyer_agent_designation": null,
        "co_buyer_agent_direct_phone": null,
        "co_buyer_agent_email": null,
        "co_buyer_agent_fax": null,
        "co_buyer_agent_first_name": null,
        "co_buyer_agent_full_name": null,
        "co_buyer_agent_home_phone": null,
        "co_buyer_agent_key": null,
        "co_buyer_agent_key_numeric": null,
        "co_buyer_agent_last_name": null,
        "co_buyer_agent_middle_name": null,
        "co_buyer_agent_mls_id": null,
        "co_buyer_agent_mobile_phone": null,
        "co_buyer_agent_name_prefix": null,
        "co_buyer_agent_name_suffix": null,
        "co_buyer_agent_office_phone_ext": null,
        "co_buyer_agent_office_phone": null,
        "co_buyer_agent_pager": null,
        "co_buyer_agent_preferred_phone_ext": null,
        "co_buyer_agent_preferred_phone": null,
        "co_buyer_agent_state_license": null,
        "co_buyer_agent_toll_free_phone": null,
        "co_buyer_agent_url": null,
        "co_buyer_agent_voice_mail_ext": null,
        "co_buyer_agent_voice_mail": null
    },
    "co_buyer_agent2": {
      "user_id": null,
        "co_buyer_agent2_aor": null,
        "co_buyer_agent2_designation": null,
        "co_buyer_agent2_direct_phone": null,
        "co_buyer_agent2_email": null,
        "co_buyer_agent2_fax": null,
        "co_buyer_agent2_first_name": null,
        "co_buyer_agent2_full_name": null,
        "co_buyer_agent2_home_phone": null,
        "co_buyer_agent2_key": null,
        "co_buyer_agent2_key_numeric": null,
        "co_buyer_agent2_last_name": null,
        "co_buyer_agent2_middle_name": null,
        "co_buyer_agent2_mls_id": null,
        "co_buyer_agent2_mobile_phone": null,
        "co_buyer_agent2_name_prefix": null,
        "co_buyer_agent2_name_suffix": null,
        "co_buyer_agent2_office_phone_ext": null,
        "co_buyer_agent2_office_phone": null,
        "co_buyer_agent2_pager": null,
        "co_buyer_agent2_preferred_phone_ext": null,
        "co_buyer_agent2_preferred_phone": null,
        "co_buyer_agent2_state_license": null,
        "co_buyer_agent2_toll_free_phone": null,
        "co_buyer_agent2_url": null,
        "co_buyer_agent2_voice_mail_ext": null,
        "co_buyer_agent2_voice_mail": null
    },
    "co_buyer_agent3": {
      "user_id": null,
        "co_buyer_agent3_aor": null,
        "co_buyer_agent3_designation": null,
        "co_buyer_agent3_direct_phone": null,
        "co_buyer_agent3_email": null,
        "co_buyer_agent3_fax": null,
        "co_buyer_agent3_first_name": null,
        "co_buyer_agent3_full_name": null,
        "co_buyer_agent3_home_phone": null,
        "co_buyer_agent3_key": null,
        "co_buyer_agent3_key_numeric": null,
        "co_buyer_agent3_last_name": null,
        "co_buyer_agent3_middle_name": null,
        "co_buyer_agent3_mls_id": null,
        "co_buyer_agent3_mobile_phone": null,
        "co_buyer_agent3_name_prefix": null,
        "co_buyer_agent3_name_suffix": null,
        "co_buyer_agent3_office_phone_ext": null,
        "co_buyer_agent3_office_phone": null,
        "co_buyer_agent3_pager": null,
        "co_buyer_agent3_preferred_phone_ext": null,
        "co_buyer_agent3_preferred_phone": null,
        "co_buyer_agent3_state_license": null,
        "co_buyer_agent3_toll_free_phone": null,
        "co_buyer_agent3_url": null,
        "co_buyer_agent3_voice_mail_ext": null,
        "co_buyer_agent3_voice_mail": null
    },
    "co_buyer_agent4": {
      "user_id": null,
        "co_buyer_agent4_aor": null,
        "co_buyer_agent4_designation": null,
        "co_buyer_agent4_direct_phone": null,
        "co_buyer_agent4_email": null,
        "co_buyer_agent4_fax": null,
        "co_buyer_agent4_first_name": null,
        "co_buyer_agent4_full_name": null,
        "co_buyer_agent4_home_phone": null,
        "co_buyer_agent4_key": null,
        "co_buyer_agent4_key_numeric": null,
        "co_buyer_agent4_last_name": null,
        "co_buyer_agent4_middle_name": null,
        "co_buyer_agent4_mls_id": null,
        "co_buyer_agent4_mobile_phone": null,
        "co_buyer_agent4_name_prefix": null,
        "co_buyer_agent4_name_suffix": null,
        "co_buyer_agent4_office_phone_ext": null,
        "co_buyer_agent4_office_phone": null,
        "co_buyer_agent4_pager": null,
        "co_buyer_agent4_preferred_phone_ext": null,
        "co_buyer_agent4_preferred_phone": null,
        "co_buyer_agent4_state_license": null,
        "co_buyer_agent4_toll_free_phone": null,
        "co_buyer_agent4_url": null,
        "co_buyer_agent4_voice_mail_ext": null,
        "co_buyer_agent4_voice_mail": null
    },
    "co_buyer_agent5": {
      "user_id": null,
        "co_buyer_agent5_aor": null,
        "co_buyer_agent5_designation": null,
        "co_buyer_agent5_direct_phone": null,
        "co_buyer_agent5_email": null,
        "co_buyer_agent5_fax": null,
        "co_buyer_agent5_first_name": null,
        "co_buyer_agent5_full_name": null,
        "co_buyer_agent5_home_phone": null,
        "co_buyer_agent5_key": null,
        "co_buyer_agent5_key_numeric": null,
        "co_buyer_agent5_last_name": null,
        "co_buyer_agent5_middle_name": null,
        "co_buyer_agent5_mls_id": null,
        "co_buyer_agent5_mobile_phone": null,
        "co_buyer_agent5_name_prefix": null,
        "co_buyer_agent5_name_suffix": null,
        "co_buyer_agent5_office_phone_ext": null,
        "co_buyer_agent5_office_phone": null,
        "co_buyer_agent5_pager": null,
        "co_buyer_agent5_preferred_phone_ext": null,
        "co_buyer_agent5_preferred_phone": null,
        "co_buyer_agent5_state_license": null,
        "co_buyer_agent5_toll_free_phone": null,
        "co_buyer_agent5_url": null,
        "co_buyer_agent5_voice_mail_ext": null,
        "co_buyer_agent5_voice_mail": null
    },
    "co_buyer_office": {
      "co_buyer_office_aor": null,
        "co_buyer_office_email": null,
        "co_buyer_office_fax": null,
        "co_buyer_office_key": null,
        "co_buyer_office_key_numeric": null,
        "co_buyer_office_mls_id": null,
        "co_buyer_office_name": null,
        "co_buyer_office_phone_ext": null,
        "co_buyer_office_phone": null,
        "co_buyer_office_url": null,
        "office": null
    },
    "co_list_agent": {
      "user_id": 1011527,
        "co_list_agent_aor": null,
        "co_list_agent_designation": "Associate Broker, Broker, BPOR: Broker Price Opinion Resource, B.S. Real Estate, CAM: Certified Apartment Manager, CBR: Certified Buyer Representative, Commercial Sales/Leasing, CRB℠: Certified Real Estate Brokerage Manager, e-PRO, WPS: Waterfront Property Specialist, SRS: Seller Representative Specialist, SFR: Short Sales & Foreclosure Resource, SIOR: Society of Industrial and Office REALTORS, SRES: Seniors Real Estate Specialist",
        "co_list_agent_direct_phone": null,
        "co_list_agent_email": "ian.leon+user4@tribusgroup.com",
        "co_list_agent_fax": null,
        "co_list_agent_first_name": "User",
        "co_list_agent_full_name": null,
        "co_list_agent_home_phone": null,
        "co_list_agent_key": null,
        "co_list_agent_key_numeric": null,
        "co_list_agent_last_name": "Fo'ur",
        "co_list_agent_middle_name": null,
        "co_list_agent_mls_id": null,
        "co_list_agent_mobile_phone": null,
        "co_list_agent_name_prefix": null,
        "co_list_agent_name_suffix": null,
        "co_list_agent_office_phone_ext": null,
        "co_list_agent_office_phone": null,
        "co_list_agent_pager": null,
        "co_list_agent_preferred_phone_ext": null,
        "co_list_agent_preferred_phone": null,
        "co_list_agent_state_license": null,
        "co_list_agent_toll_free_phone": null,
        "co_list_agent_url": null,
        "co_list_agent_voice_mail_ext": null,
        "co_list_agent_voice_mail": null
    },
    "co_list_agent2": {
      "user_id": null,
        "co_list_agent2_aor": null,
        "co_list_agent2_designation": null,
        "co_list_agent2_direct_phone": null,
        "co_list_agent2_email": null,
        "co_list_agent2_fax": null,
        "co_list_agent2_first_name": null,
        "co_list_agent2_full_name": null,
        "co_list_agent2_home_phone": null,
        "co_list_agent2_key": null,
        "co_list_agent2_key_numeric": null,
        "co_list_agent2_last_name": null,
        "co_list_agent2_middle_name": null,
        "co_list_agent2_mls_id": null,
        "co_list_agent2_mobile_phone": null,
        "co_list_agent2_name_prefix": null,
        "co_list_agent2_name_suffix": null,
        "co_list_agent2_office_phone_ext": null,
        "co_list_agent2_office_phone": null,
        "co_list_agent2_pager": null,
        "co_list_agent2_preferred_phone_ext": null,
        "co_list_agent2_preferred_phone": null,
        "co_list_agent2_state_license": null,
        "co_list_agent2_toll_free_phone": null,
        "co_list_agent2_url": null,
        "co_list_agent2_voice_mail_ext": null,
        "co_list_agent2_voice_mail": null
    },
    "co_list_agent3": {
      "user_id": null,
        "co_list_agent3_aor": null,
        "co_list_agent3_designation": null,
        "co_list_agent3_direct_phone": null,
        "co_list_agent3_email": null,
        "co_list_agent3_fax": null,
        "co_list_agent3_first_name": null,
        "co_list_agent3_full_name": null,
        "co_list_agent3_home_phone": null,
        "co_list_agent3_key": null,
        "co_list_agent3_key_numeric": null,
        "co_list_agent3_last_name": null,
        "co_list_agent3_middle_name": null,
        "co_list_agent3_mls_id": null,
        "co_list_agent3_mobile_phone": null,
        "co_list_agent3_name_prefix": null,
        "co_list_agent3_name_suffix": null,
        "co_list_agent3_office_phone_ext": null,
        "co_list_agent3_office_phone": null,
        "co_list_agent3_pager": null,
        "co_list_agent3_preferred_phone_ext": null,
        "co_list_agent3_preferred_phone": null,
        "co_list_agent3_state_license": null,
        "co_list_agent3_toll_free_phone": null,
        "co_list_agent3_url": null,
        "co_list_agent3_voice_mail_ext": null,
        "co_list_agent3_voice_mail": null
    },
    "co_list_agent4": {
      "user_id": null,
        "co_list_agent4_aor": null,
        "co_list_agent4_designation": null,
        "co_list_agent4_direct_phone": null,
        "co_list_agent4_email": null,
        "co_list_agent4_fax": null,
        "co_list_agent4_first_name": null,
        "co_list_agent4_full_name": null,
        "co_list_agent4_home_phone": null,
        "co_list_agent4_key": null,
        "co_list_agent4_key_numeric": null,
        "co_list_agent4_last_name": null,
        "co_list_agent4_middle_name": null,
        "co_list_agent4_mls_id": null,
        "co_list_agent4_mobile_phone": null,
        "co_list_agent4_name_prefix": null,
        "co_list_agent4_name_suffix": null,
        "co_list_agent4_office_phone_ext": null,
        "co_list_agent4_office_phone": null,
        "co_list_agent4_pager": null,
        "co_list_agent4_preferred_phone_ext": null,
        "co_list_agent4_preferred_phone": null,
        "co_list_agent4_state_license": null,
        "co_list_agent4_toll_free_phone": null,
        "co_list_agent4_url": null,
        "co_list_agent4_voice_mail_ext": null,
        "co_list_agent4_voice_mail": null
    },
    "co_list_agent5": {
      "user_id": null,
        "co_list_agent5_aor": null,
        "co_list_agent5_designation": null,
        "co_list_agent5_direct_phone": null,
        "co_list_agent5_email": null,
        "co_list_agent5_fax": null,
        "co_list_agent5_first_name": null,
        "co_list_agent5_full_name": null,
        "co_list_agent5_home_phone": null,
        "co_list_agent5_key": null,
        "co_list_agent5_key_numeric": null,
        "co_list_agent5_last_name": null,
        "co_list_agent5_middle_name": null,
        "co_list_agent5_mls_id": null,
        "co_list_agent5_mobile_phone": null,
        "co_list_agent5_name_prefix": null,
        "co_list_agent5_name_suffix": null,
        "co_list_agent5_office_phone_ext": null,
        "co_list_agent5_office_phone": null,
        "co_list_agent5_pager": null,
        "co_list_agent5_preferred_phone_ext": null,
        "co_list_agent5_preferred_phone": null,
        "co_list_agent5_state_license": null,
        "co_list_agent5_toll_free_phone": null,
        "co_list_agent5_url": null,
        "co_list_agent5_voice_mail_ext": null,
        "co_list_agent5_voice_mail": null
    },
    "co_list_office": {
      "co_list_office_aor": null,
        "co_list_office_email": null,
        "co_list_office_fax": null,
        "co_list_office_key": null,
        "co_list_office_key_numeric": null,
        "co_list_office_mls_id": null,
        "co_list_office_name": null,
        "co_list_office_phone_ext": null,
        "co_list_office_phone": null,
        "co_list_office_url": null,
        "office": null
    },
    "co_relocation_agent": {
      "user_id": null,
        "co_relocation_agent_aor": null,
        "co_relocation_agent_designation": null,
        "co_relocation_agent_direct_phone": null,
        "co_relocation_agent_email": null,
        "co_relocation_agent_fax": null,
        "co_relocation_agent_first_name": null,
        "co_relocation_agent_full_name": null,
        "co_relocation_agent_home_phone": null,
        "co_relocation_agent_key": null,
        "co_relocation_agent_key_numeric": null,
        "co_relocation_agent_last_name": null,
        "co_relocation_agent_middle_name": null,
        "co_relocation_agent_mls_id": null,
        "co_relocation_agent_mobile_phone": null,
        "co_relocation_agent_name_prefix": null,
        "co_relocation_agent_name_suffix": null,
        "co_relocation_agent_office_phone_ext": null,
        "co_relocation_agent_office_phone": null,
        "co_relocation_agent_pager": null,
        "co_relocation_agent_preferred_phone_ext": null,
        "co_relocation_agent_preferred_phone": null,
        "co_relocation_agent_state_license": null,
        "co_relocation_agent_toll_free_phone": null,
        "co_relocation_agent_url": null,
        "co_relocation_agent_voice_mail_ext": null,
        "co_relocation_agent_voice_mail": null
    },
    "co_relocation_agent2": {
      "user_id": null,
        "co_relocation_agent2_aor": null,
        "co_relocation_agent2_designation": null,
        "co_relocation_agent2_direct_phone": null,
        "co_relocation_agent2_email": null,
        "co_relocation_agent2_fax": null,
        "co_relocation_agent2_first_name": null,
        "co_relocation_agent2_full_name": null,
        "co_relocation_agent2_home_phone": null,
        "co_relocation_agent2_key": null,
        "co_relocation_agent2_key_numeric": null,
        "co_relocation_agent2_last_name": null,
        "co_relocation_agent2_middle_name": null,
        "co_relocation_agent2_mls_id": null,
        "co_relocation_agent2_mobile_phone": null,
        "co_relocation_agent2_name_prefix": null,
        "co_relocation_agent2_name_suffix": null,
        "co_relocation_agent2_office_phone_ext": null,
        "co_relocation_agent2_office_phone": null,
        "co_relocation_agent2_pager": null,
        "co_relocation_agent2_preferred_phone_ext": null,
        "co_relocation_agent2_preferred_phone": null,
        "co_relocation_agent2_state_license": null,
        "co_relocation_agent2_toll_free_phone": null,
        "co_relocation_agent2_url": null,
        "co_relocation_agent2_voice_mail_ext": null,
        "co_relocation_agent2_voice_mail": null
    },
    "co_relocation_agent3": {
      "user_id": null,
        "co_relocation_agent3_aor": null,
        "co_relocation_agent3_designation": null,
        "co_relocation_agent3_direct_phone": null,
        "co_relocation_agent3_email": null,
        "co_relocation_agent3_fax": null,
        "co_relocation_agent3_first_name": null,
        "co_relocation_agent3_full_name": null,
        "co_relocation_agent3_home_phone": null,
        "co_relocation_agent3_key": null,
        "co_relocation_agent3_key_numeric": null,
        "co_relocation_agent3_last_name": null,
        "co_relocation_agent3_middle_name": null,
        "co_relocation_agent3_mls_id": null,
        "co_relocation_agent3_mobile_phone": null,
        "co_relocation_agent3_name_prefix": null,
        "co_relocation_agent3_name_suffix": null,
        "co_relocation_agent3_office_phone_ext": null,
        "co_relocation_agent3_office_phone": null,
        "co_relocation_agent3_pager": null,
        "co_relocation_agent3_preferred_phone_ext": null,
        "co_relocation_agent3_preferred_phone": null,
        "co_relocation_agent3_state_license": null,
        "co_relocation_agent3_toll_free_phone": null,
        "co_relocation_agent3_url": null,
        "co_relocation_agent3_voice_mail_ext": null,
        "co_relocation_agent3_voice_mail": null
    },
    "co_relocation_agent4": {
      "user_id": null,
        "co_relocation_agent4_aor": null,
        "co_relocation_agent4_designation": null,
        "co_relocation_agent4_direct_phone": null,
        "co_relocation_agent4_email": null,
        "co_relocation_agent4_fax": null,
        "co_relocation_agent4_first_name": null,
        "co_relocation_agent4_full_name": null,
        "co_relocation_agent4_home_phone": null,
        "co_relocation_agent4_key": null,
        "co_relocation_agent4_key_numeric": null,
        "co_relocation_agent4_last_name": null,
        "co_relocation_agent4_middle_name": null,
        "co_relocation_agent4_mls_id": null,
        "co_relocation_agent4_mobile_phone": null,
        "co_relocation_agent4_name_prefix": null,
        "co_relocation_agent4_name_suffix": null,
        "co_relocation_agent4_office_phone_ext": null,
        "co_relocation_agent4_office_phone": null,
        "co_relocation_agent4_pager": null,
        "co_relocation_agent4_preferred_phone_ext": null,
        "co_relocation_agent4_preferred_phone": null,
        "co_relocation_agent4_state_license": null,
        "co_relocation_agent4_toll_free_phone": null,
        "co_relocation_agent4_url": null,
        "co_relocation_agent4_voice_mail_ext": null,
        "co_relocation_agent4_voice_mail": null
    },
    "co_relocation_agent5": {
      "user_id": null,
        "co_relocation_agent5_aor": null,
        "co_relocation_agent5_designation": null,
        "co_relocation_agent5_direct_phone": null,
        "co_relocation_agent5_email": null,
        "co_relocation_agent5_fax": null,
        "co_relocation_agent5_first_name": null,
        "co_relocation_agent5_full_name": null,
        "co_relocation_agent5_home_phone": null,
        "co_relocation_agent5_key": null,
        "co_relocation_agent5_key_numeric": null,
        "co_relocation_agent5_last_name": null,
        "co_relocation_agent5_middle_name": null,
        "co_relocation_agent5_mls_id": null,
        "co_relocation_agent5_mobile_phone": null,
        "co_relocation_agent5_name_prefix": null,
        "co_relocation_agent5_name_suffix": null,
        "co_relocation_agent5_office_phone_ext": null,
        "co_relocation_agent5_office_phone": null,
        "co_relocation_agent5_pager": null,
        "co_relocation_agent5_preferred_phone_ext": null,
        "co_relocation_agent5_preferred_phone": null,
        "co_relocation_agent5_state_license": null,
        "co_relocation_agent5_toll_free_phone": null,
        "co_relocation_agent5_url": null,
        "co_relocation_agent5_voice_mail_ext": null,
        "co_relocation_agent5_voice_mail": null
    },
    "co_showing_agent": {
      "user_id": null,
        "co_showing_agent_aor": null,
        "co_showing_agent_designation": null,
        "co_showing_agent_direct_phone": null,
        "co_showing_agent_email": null,
        "co_showing_agent_fax": null,
        "co_showing_agent_first_name": null,
        "co_showing_agent_full_name": null,
        "co_showing_agent_home_phone": null,
        "co_showing_agent_key": null,
        "co_showing_agent_key_numeric": null,
        "co_showing_agent_last_name": null,
        "co_showing_agent_middle_name": null,
        "co_showing_agent_mls_id": null,
        "co_showing_agent_mobile_phone": null,
        "co_showing_agent_name_prefix": null,
        "co_showing_agent_name_suffix": null,
        "co_showing_agent_office_phone_ext": null,
        "co_showing_agent_office_phone": null,
        "co_showing_agent_pager": null,
        "co_showing_agent_preferred_phone_ext": null,
        "co_showing_agent_preferred_phone": null,
        "co_showing_agent_state_license": null,
        "co_showing_agent_toll_free_phone": null,
        "co_showing_agent_url": null,
        "co_showing_agent_voice_mail_ext": null,
        "co_showing_agent_voice_mail": null
    },
    "co_showing_agent2": {
      "user_id": null,
        "co_showing_agent2_aor": null,
        "co_showing_agent2_designation": null,
        "co_showing_agent2_direct_phone": null,
        "co_showing_agent2_email": null,
        "co_showing_agent2_fax": null,
        "co_showing_agent2_first_name": null,
        "co_showing_agent2_full_name": null,
        "co_showing_agent2_home_phone": null,
        "co_showing_agent2_key": null,
        "co_showing_agent2_key_numeric": null,
        "co_showing_agent2_last_name": null,
        "co_showing_agent2_middle_name": null,
        "co_showing_agent2_mls_id": null,
        "co_showing_agent2_mobile_phone": null,
        "co_showing_agent2_name_prefix": null,
        "co_showing_agent2_name_suffix": null,
        "co_showing_agent2_office_phone_ext": null,
        "co_showing_agent2_office_phone": null,
        "co_showing_agent2_pager": null,
        "co_showing_agent2_preferred_phone_ext": null,
        "co_showing_agent2_preferred_phone": null,
        "co_showing_agent2_state_license": null,
        "co_showing_agent2_toll_free_phone": null,
        "co_showing_agent2_url": null,
        "co_showing_agent2_voice_mail_ext": null,
        "co_showing_agent2_voice_mail": null
    },
    "co_showing_agent3": {
      "user_id": null,
        "co_showing_agent3_aor": null,
        "co_showing_agent3_designation": null,
        "co_showing_agent3_direct_phone": null,
        "co_showing_agent3_email": null,
        "co_showing_agent3_fax": null,
        "co_showing_agent3_first_name": null,
        "co_showing_agent3_full_name": null,
        "co_showing_agent3_home_phone": null,
        "co_showing_agent3_key": null,
        "co_showing_agent3_key_numeric": null,
        "co_showing_agent3_last_name": null,
        "co_showing_agent3_middle_name": null,
        "co_showing_agent3_mls_id": null,
        "co_showing_agent3_mobile_phone": null,
        "co_showing_agent3_name_prefix": null,
        "co_showing_agent3_name_suffix": null,
        "co_showing_agent3_office_phone_ext": null,
        "co_showing_agent3_office_phone": null,
        "co_showing_agent3_pager": null,
        "co_showing_agent3_preferred_phone_ext": null,
        "co_showing_agent3_preferred_phone": null,
        "co_showing_agent3_state_license": null,
        "co_showing_agent3_toll_free_phone": null,
        "co_showing_agent3_url": null,
        "co_showing_agent3_voice_mail_ext": null,
        "co_showing_agent3_voice_mail": null
    },
    "co_showing_agent4": {
      "user_id": null,
        "co_showing_agent4_aor": null,
        "co_showing_agent4_designation": null,
        "co_showing_agent4_direct_phone": null,
        "co_showing_agent4_email": null,
        "co_showing_agent4_fax": null,
        "co_showing_agent4_first_name": null,
        "co_showing_agent4_full_name": null,
        "co_showing_agent4_home_phone": null,
        "co_showing_agent4_key": null,
        "co_showing_agent4_key_numeric": null,
        "co_showing_agent4_last_name": null,
        "co_showing_agent4_middle_name": null,
        "co_showing_agent4_mls_id": null,
        "co_showing_agent4_mobile_phone": null,
        "co_showing_agent4_name_prefix": null,
        "co_showing_agent4_name_suffix": null,
        "co_showing_agent4_office_phone_ext": null,
        "co_showing_agent4_office_phone": null,
        "co_showing_agent4_pager": null,
        "co_showing_agent4_preferred_phone_ext": null,
        "co_showing_agent4_preferred_phone": null,
        "co_showing_agent4_state_license": null,
        "co_showing_agent4_toll_free_phone": null,
        "co_showing_agent4_url": null,
        "co_showing_agent4_voice_mail_ext": null,
        "co_showing_agent4_voice_mail": null
    },
    "co_showing_agent5": {
      "user_id": null,
        "co_showing_agent5_aor": null,
        "co_showing_agent5_designation": null,
        "co_showing_agent5_direct_phone": null,
        "co_showing_agent5_email": null,
        "co_showing_agent5_fax": null,
        "co_showing_agent5_first_name": null,
        "co_showing_agent5_full_name": null,
        "co_showing_agent5_home_phone": null,
        "co_showing_agent5_key": null,
        "co_showing_agent5_key_numeric": null,
        "co_showing_agent5_last_name": null,
        "co_showing_agent5_middle_name": null,
        "co_showing_agent5_mls_id": null,
        "co_showing_agent5_mobile_phone": null,
        "co_showing_agent5_name_prefix": null,
        "co_showing_agent5_name_suffix": null,
        "co_showing_agent5_office_phone_ext": null,
        "co_showing_agent5_office_phone": null,
        "co_showing_agent5_pager": null,
        "co_showing_agent5_preferred_phone_ext": null,
        "co_showing_agent5_preferred_phone": null,
        "co_showing_agent5_state_license": null,
        "co_showing_agent5_toll_free_phone": null,
        "co_showing_agent5_url": null,
        "co_showing_agent5_voice_mail_ext": null,
        "co_showing_agent5_voice_mail": null
    },
    "list_agent": {
      "user_id": 1011525,
        "list_agent_aor": null,
        "list_agent_designation": "",
        "list_agent_direct_phone": "4444444444",
        "list_agent_email": "ian.leon+user2@tribusgroup.com",
        "list_agent_fax": null,
        "list_agent_first_name": "User",
        "list_agent_full_name": "User Two",
        "list_agent_home_phone": null,
        "list_agent_key": null,
        "list_agent_key_numeric": null,
        "list_agent_last_name": "Two",
        "list_agent_middle_name": null,
        "list_agent_mls_id": null,
        "list_agent_mobile_phone": null,
        "list_agent_name_prefix": null,
        "list_agent_name_suffix": null,
        "list_agent_office_phone_ext": null,
        "list_agent_office_phone": null,
        "list_agent_pager": null,
        "list_agent_preferred_phone_ext": null,
        "list_agent_preferred_phone": "4444444444",
        "list_agent_state_license": null,
        "list_agent_toll_free_phone": null,
        "list_agent_url": null,
        "list_agent_voice_mail_ext": null,
        "list_agent_voice_mail": null
    },
    "list_office": {
      "list_office_aor": null,
        "list_office_email": null,
        "list_office_fax": null,
        "list_office_key": null,
        "list_office_key_numeric": null,
        "list_office_mls_id": null,
        "list_office_name": null,
        "list_office_phone_ext": null,
        "list_office_phone": null,
        "list_office_url": null,
        "office": null
    },
    "relocation_agent": {
      "user_id": null,
        "relocation_agent_aor": null,
        "relocation_agent_designation": null,
        "relocation_agent_direct_phone": null,
        "relocation_agent_email": null,
        "relocation_agent_fax": null,
        "relocation_agent_first_name": null,
        "relocation_agent_full_name": null,
        "relocation_agent_home_phone": null,
        "relocation_agent_key": null,
        "relocation_agent_key_numeric": null,
        "relocation_agent_last_name": null,
        "relocation_agent_middle_name": null,
        "relocation_agent_mls_id": null,
        "relocation_agent_mobile_phone": null,
        "relocation_agent_name_prefix": null,
        "relocation_agent_name_suffix": null,
        "relocation_agent_office_phone_ext": null,
        "relocation_agent_office_phone": null,
        "relocation_agent_pager": null,
        "relocation_agent_preferred_phone_ext": null,
        "relocation_agent_preferred_phone": null,
        "relocation_agent_state_license": null,
        "relocation_agent_toll_free_phone": null,
        "relocation_agent_url": null,
        "relocation_agent_voice_mail_ext": null,
        "relocation_agent_voice_mail": null
    },
    "showing_agent": {
      "user_id": null,
        "showing_agent_aor": null,
        "showing_agent_designation": null,
        "showing_agent_direct_phone": null,
        "showing_agent_email": null,
        "showing_agent_fax": null,
        "showing_agent_first_name": null,
        "showing_agent_full_name": null,
        "showing_agent_home_phone": null,
        "showing_agent_key": null,
        "showing_agent_key_numeric": null,
        "showing_agent_last_name": null,
        "showing_agent_middle_name": null,
        "showing_agent_mls_id": null,
        "showing_agent_mobile_phone": null,
        "showing_agent_name_prefix": null,
        "showing_agent_name_suffix": null,
        "showing_agent_office_phone_ext": null,
        "showing_agent_office_phone": null,
        "showing_agent_pager": null,
        "showing_agent_preferred_phone_ext": null,
        "showing_agent_preferred_phone": null,
        "showing_agent_state_license": null,
        "showing_agent_toll_free_phone": null,
        "showing_agent_url": null,
        "showing_agent_voice_mail_ext": null,
        "showing_agent_voice_mail": null
    },
    "team": {
      "buyer_team_key": null,
        "buyer_team_key_numeric": null,
        "buyer_team_name": null,
        "list_team_key": null,
        "list_team_key_numeric": null,
        "list_team_name": null
    }
  },
  "closing": {
    "availability_date": null,
      "buyer_financing": null,
      "concessions_amount": null,
      "concessions_comments": null,
      "concessions": null,
      "contingency": null,
      "possession": null
  },
  "compensation": {
    "buyer_agency_compensation": null,
      "buyer_agency_compensation_type": null,
      "dual_variable_compensation_y_n": null,
      "lease_renewal_compensation": null,
      "sub_agency_compensation": null,
      "sub_agency_compensation_type": null,
      "transaction_broker_compensation": null,
      "transaction_broker_compensation_type": null
  },
  "contract": {
    "current_financing": null,
      "disclosures": null,
      "exclusions": null,
      "inclusions": null,
      "listing_terms": null,
      "ownership": null,
      "special_listing_conditions": null,
      "common_interest": null,
      "foreclosure_y_n": false,
      "short_sale_y_n": false
  },
  "dates": {
    "cancelation_date": null,
      "close_date": null,
      "contingent_date": null,
      "contract_status_change_date": null,
      "cumulative_days_on_market": null,
      "days_on_market": null,
      "expiration_date": null,
      "listing_contract_date": null,
      "major_change_timestamp": null,
      "major_change_type": null,
      "modification_timestamp": "2022-02-04T14:58:25.491Z",
      "off_market_date": null,
      "off_market_timestamp": null,
      "on_market_date": null,
      "on_market_timestamp": null,
      "original_entry_timestamp": "2021-09-20T23:16:45.081Z",
      "pending_timestamp": null,
      "price_change_timestamp": null,
      "purchase_contract_date": null,
      "status_change_timestamp": null,
      "total_days_on_market": null,
      "withdrawn_date": null
  },
  "marketing": {
    "internet_address_display_y_n": null,
      "internet_automated_valuation_display_y_n": null,
      "internet_consumer_comment_y_n": null,
      "internet_entire_listing_display_y_n": true,
      "sign_on_property_y_n": null,
      "single_property_website_url": "https://spw.tst/",
      "single_property_website_y_n": true,
      "syndicate_to": null,
      "syndicate_y_n": false,
      "virtual_tour_url_branded": null,
      "virtual_tour_url_unbranded": null,
      "vow_y_n": null,
      "send_email": false
  },
  "media": {
    "documents_available": null,
      "documents_change_timestamp": null,
      "documents_count": null,
      "photos_change_timestamp": null,
      "photos_count": null,
      "videos_change_timestamp": null,
      "videos_count": null
  },
  "mls_status_snapshots": [
    {
      "modification_timestamp": "2022-02-04T14:58:26.053Z",
      "mls_status": "Sold"
    }
  ],
    "price": {
    "close_price": null,
      "list_price": "10000000.0",
      "list_price_low": null,
      "original_list_price": null,
      "previous_list_price": null,
      "list_price_snapshots": [
      {
        "modification_timestamp": "2021-11-30T17:18:57.102Z",
        "list_price": 10000000
      }
    ]
  },
  "remarks": {
    "excerpt": "",
      "headline": null,
      "private_office_remarks": null,
      "private_remarks": null,
      "public_remarks": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Porta lorem mollis aliquam ut porttitor leo a diam sollicitudin. Elementum curabitur vitae nunc sed velit dignissim sodales. Elementum curabitur vitae nunc sed velit dignissim sodales. Pharetra et ultrices neque ornare aenean euismod elementum nisi. Libero enim sed faucibus turpis in. Elit duis tristique sollicitudin nibh sit amet commodo nulla facilisi. Lectus magna fringilla urna porttitor rhoncus dolor. Cum sociis natoque penatibus et magnis dis. Donec pretium vulputate sapien nec sagittis aliquam malesuada bibendum arcu. <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/5qap5aO4i9A\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>",
      "publication_remarks": null,
      "publication_remarks_approved_y_n": false,
      "syndication_remarks": null
  },
  "showing": {
    "access_code": null,
      "lock_box_location": null,
      "lock_box_serial_number": null,
      "lock_box_type": null,
      "showing_advance_notice": null,
      "showing_attended_y_n": null,
      "showing_contact_name": null,
      "showing_contact_phone_ext": null,
      "showing_contact_phone": null,
      "showing_contact_type": null,
      "showing_days": null,
      "showing_instructions": null,
      "showing_requirements": null,
      "showing_start_time": null,
      "showing_end_time": null
  }
},
  "location": {
  "address": {
    "address_slug": "181-nw-97th-ave-515-miami-fl-33172",
      "carrier_route": null,
      "city": "Miami",
      "country": null,
      "county_or_parish": "Ianscounty",
      "postal_city": null,
      "postal_code": "33172",
      "postal_code_plus_4": null,
      "state_or_province": "FL",
      "street_additional_info": null,
      "street_dir_prefix": null,
      "street_dir_suffix": null,
      "street_name": "181 NW 97th Ave",
      "street_number": null,
      "street_number_numeric": null,
      "street_suffix": null,
      "street_suffix_modifier": null,
      "township": null,
      "unit_number": "515",
      "unparsed_address": null
  },
  "area": {
    "city_region": null,
      "continent_region": null,
      "country_region": null,
      "mls_area_major": "Iansarea",
      "mls_area_minor": "Ianssubarea",
      "state_region": null,
      "subdivision_name": "Iansneighborhood"
  },
  "gis": {
    "cross_street": null,
      "directions": null,
      "elevation": null,
      "elevation_units": null,
      "latitude": null,
      "longitude": null,
      "map_coordinate": null,
      "map_coordinate_source": null,
      "map_url": null
  },
  "school": {
    "elementary_school_district": "e",
      "elementary_school": null,
      "high_school_district": "h",
      "high_school": null,
      "middle_or_junior_school_district": "m",
      "middle_or_junior_school": null
  }
},
  "media": [
  {
    "id": 2367286983,
    "media_key": null,
    "media_status": "Active",
    "modification_timestamp": null,
    "media_type": null,
    "media_category": "Photo",
    "image_size_description": "Thumb",
    "order": 1,
    "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/4699542d-043a-481f-81d1-806ac10655c2.thumb.png",
    "short_description": null,
    "long_description": null,
    "changed_by_member_id": null,
    "changed_by_member_key": null,
    "changed_by_member_key_numeric": null,
    "class_name": null,
    "image_height": 350,
    "image_of": null,
    "image_width": 331,
    "media_html": null,
    "media_key_numeric": null,
    "media_modification_timestamp": null,
    "media_object_id": null,
    "originating_system_id": null,
    "originating_system_media_key": null,
    "originating_system_name": null,
    "permission": null,
    "preferred_photo_y_n": null,
    "resource_record_id": null,
    "resource_record_key_numeric": null,
    "source_system_id": null,
    "source_system_media_key": null,
    "source_system_name": null,
    "created_at": "2022-01-19T16:36:02.770Z",
    "updated_at": "2022-01-19T16:36:02.770Z"
  },
  {
    "id": 2367286987,
    "media_key": null,
    "media_status": "Active",
    "modification_timestamp": null,
    "media_type": null,
    "media_category": "Photo",
    "image_size_description": "Largest",
    "order": 1,
    "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/4699542d-043a-481f-81d1-806ac10655c2.png",
    "short_description": null,
    "long_description": null,
    "changed_by_member_id": null,
    "changed_by_member_key": null,
    "changed_by_member_key_numeric": null,
    "class_name": null,
    "image_height": 1360,
    "image_of": null,
    "image_width": 1288,
    "media_html": null,
    "media_key_numeric": null,
    "media_modification_timestamp": null,
    "media_object_id": null,
    "originating_system_id": null,
    "originating_system_media_key": null,
    "originating_system_name": null,
    "permission": null,
    "preferred_photo_y_n": null,
    "resource_record_id": null,
    "resource_record_key_numeric": null,
    "source_system_id": null,
    "source_system_media_key": null,
    "source_system_name": null,
    "created_at": "2022-01-19T16:36:02.786Z",
    "updated_at": "2022-01-19T16:36:02.786Z"
  },
  {
    "id": 2367286988,
    "media_key": null,
    "media_status": "Active",
    "modification_timestamp": null,
    "media_type": null,
    "media_category": "Photo",
    "image_size_description": "Thumb",
    "order": 2,
    "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/7a1ded91-f6f6-4fd2-947d-d2be6fb87335.thumb.png",
    "short_description": null,
    "long_description": null,
    "changed_by_member_id": null,
    "changed_by_member_key": null,
    "changed_by_member_key_numeric": null,
    "class_name": null,
    "image_height": 313,
    "image_of": null,
    "image_width": 350,
    "media_html": null,
    "media_key_numeric": null,
    "media_modification_timestamp": null,
    "media_object_id": null,
    "originating_system_id": null,
    "originating_system_media_key": null,
    "originating_system_name": null,
    "permission": null,
    "preferred_photo_y_n": null,
    "resource_record_id": null,
    "resource_record_key_numeric": null,
    "source_system_id": null,
    "source_system_media_key": null,
    "source_system_name": null,
    "created_at": "2022-01-19T16:36:02.792Z",
    "updated_at": "2022-01-19T16:36:02.792Z"
  },
  {
    "id": 2367286989,
    "media_key": null,
    "media_status": "Active",
    "modification_timestamp": null,
    "media_type": null,
    "media_category": "Photo",
    "image_size_description": "Largest",
    "order": 2,
    "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/7a1ded91-f6f6-4fd2-947d-d2be6fb87335.png",
    "short_description": null,
    "long_description": null,
    "changed_by_member_id": null,
    "changed_by_member_key": null,
    "changed_by_member_key_numeric": null,
    "class_name": null,
    "image_height": 1392,
    "image_of": null,
    "image_width": 1558,
    "media_html": null,
    "media_key_numeric": null,
    "media_modification_timestamp": null,
    "media_object_id": null,
    "originating_system_id": null,
    "originating_system_media_key": null,
    "originating_system_name": null,
    "permission": null,
    "preferred_photo_y_n": null,
    "resource_record_id": null,
    "resource_record_key_numeric": null,
    "source_system_id": null,
    "source_system_media_key": null,
    "source_system_name": null,
    "created_at": "2022-01-19T16:36:02.796Z",
    "updated_at": "2022-01-19T16:36:02.796Z"
  },
  {
    "id": 2367286990,
    "media_key": null,
    "media_status": "Active",
    "modification_timestamp": null,
    "media_type": null,
    "media_category": "Photo",
    "image_size_description": "Thumb",
    "order": 3,
    "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/267cdd33-24ad-400d-af1d-dc8228c34186.thumb.png",
    "short_description": null,
    "long_description": null,
    "changed_by_member_id": null,
    "changed_by_member_key": null,
    "changed_by_member_key_numeric": null,
    "class_name": null,
    "image_height": 350,
    "image_of": null,
    "image_width": 350,
    "media_html": null,
    "media_key_numeric": null,
    "media_modification_timestamp": null,
    "media_object_id": null,
    "originating_system_id": null,
    "originating_system_media_key": null,
    "originating_system_name": null,
    "permission": null,
    "preferred_photo_y_n": null,
    "resource_record_id": null,
    "resource_record_key_numeric": null,
    "source_system_id": null,
    "source_system_media_key": null,
    "source_system_name": null,
    "created_at": "2022-01-19T16:36:02.800Z",
    "updated_at": "2022-01-19T16:36:02.800Z"
  },
  {
    "id": 2367286991,
    "media_key": null,
    "media_status": "Active",
    "modification_timestamp": null,
    "media_type": null,
    "media_category": "Photo",
    "image_size_description": "Largest",
    "order": 3,
    "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/267cdd33-24ad-400d-af1d-dc8228c34186.png",
    "short_description": null,
    "long_description": null,
    "changed_by_member_id": null,
    "changed_by_member_key": null,
    "changed_by_member_key_numeric": null,
    "class_name": null,
    "image_height": 1100,
    "image_of": null,
    "image_width": 1100,
    "media_html": null,
    "media_key_numeric": null,
    "media_modification_timestamp": null,
    "media_object_id": null,
    "originating_system_id": null,
    "originating_system_media_key": null,
    "originating_system_name": null,
    "permission": null,
    "preferred_photo_y_n": null,
    "resource_record_id": null,
    "resource_record_key_numeric": null,
    "source_system_id": null,
    "source_system_media_key": null,
    "source_system_name": null,
    "created_at": "2022-01-19T16:36:02.804Z",
    "updated_at": "2022-01-19T16:36:02.804Z"
  },
  {
    "id": 2367286992,
    "media_key": null,
    "media_status": "Active",
    "modification_timestamp": null,
    "media_type": null,
    "media_category": "Photo",
    "image_size_description": "Thumb",
    "order": 4,
    "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/b70ba3e2-ed24-4c1c-8524-439cf45f37b7.thumb.png",
    "short_description": null,
    "long_description": null,
    "changed_by_member_id": null,
    "changed_by_member_key": null,
    "changed_by_member_key_numeric": null,
    "class_name": null,
    "image_height": 330,
    "image_of": null,
    "image_width": 350,
    "media_html": null,
    "media_key_numeric": null,
    "media_modification_timestamp": null,
    "media_object_id": null,
    "originating_system_id": null,
    "originating_system_media_key": null,
    "originating_system_name": null,
    "permission": null,
    "preferred_photo_y_n": null,
    "resource_record_id": null,
    "resource_record_key_numeric": null,
    "source_system_id": null,
    "source_system_media_key": null,
    "source_system_name": null,
    "created_at": "2022-01-19T16:36:02.809Z",
    "updated_at": "2022-01-19T16:36:02.809Z"
  },
  {
    "id": 2367286993,
    "media_key": null,
    "media_status": "Active",
    "modification_timestamp": null,
    "media_type": null,
    "media_category": "Photo",
    "image_size_description": "Largest",
    "order": 4,
    "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/b70ba3e2-ed24-4c1c-8524-439cf45f37b7.png",
    "short_description": null,
    "long_description": null,
    "changed_by_member_id": null,
    "changed_by_member_key": null,
    "changed_by_member_key_numeric": null,
    "class_name": null,
    "image_height": 1278,
    "image_of": null,
    "image_width": 1356,
    "media_html": null,
    "media_key_numeric": null,
    "media_modification_timestamp": null,
    "media_object_id": null,
    "originating_system_id": null,
    "originating_system_media_key": null,
    "originating_system_name": null,
    "permission": null,
    "preferred_photo_y_n": null,
    "resource_record_id": null,
    "resource_record_key_numeric": null,
    "source_system_id": null,
    "source_system_media_key": null,
    "source_system_name": null,
    "created_at": "2022-01-19T16:36:02.814Z",
    "updated_at": "2022-01-19T16:36:02.814Z"
  },
  {
    "id": 2367286994,
    "media_key": null,
    "media_status": "Active",
    "modification_timestamp": null,
    "media_type": null,
    "media_category": "Photo",
    "image_size_description": "Thumb",
    "order": 5,
    "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/4b5aabca-03ca-4068-87ed-228d39da6b7a.thumb.png",
    "short_description": null,
    "long_description": null,
    "changed_by_member_id": null,
    "changed_by_member_key": null,
    "changed_by_member_key_numeric": null,
    "class_name": null,
    "image_height": 350,
    "image_of": null,
    "image_width": 344,
    "media_html": null,
    "media_key_numeric": null,
    "media_modification_timestamp": null,
    "media_object_id": null,
    "originating_system_id": null,
    "originating_system_media_key": null,
    "originating_system_name": null,
    "permission": null,
    "preferred_photo_y_n": null,
    "resource_record_id": null,
    "resource_record_key_numeric": null,
    "source_system_id": null,
    "source_system_media_key": null,
    "source_system_name": null,
    "created_at": "2022-01-19T16:36:02.819Z",
    "updated_at": "2022-01-19T16:36:02.819Z"
  },
  {
    "id": 2367286995,
    "media_key": null,
    "media_status": "Active",
    "modification_timestamp": null,
    "media_type": null,
    "media_category": "Photo",
    "image_size_description": "Largest",
    "order": 5,
    "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/4b5aabca-03ca-4068-87ed-228d39da6b7a.png",
    "short_description": null,
    "long_description": null,
    "changed_by_member_id": null,
    "changed_by_member_key": null,
    "changed_by_member_key_numeric": null,
    "class_name": null,
    "image_height": 1470,
    "image_of": null,
    "image_width": 1446,
    "media_html": null,
    "media_key_numeric": null,
    "media_modification_timestamp": null,
    "media_object_id": null,
    "originating_system_id": null,
    "originating_system_media_key": null,
    "originating_system_name": null,
    "permission": null,
    "preferred_photo_y_n": null,
    "resource_record_id": null,
    "resource_record_key_numeric": null,
    "source_system_id": null,
    "source_system_media_key": null,
    "source_system_name": null,
    "created_at": "2022-01-19T16:36:02.825Z",
    "updated_at": "2022-01-19T16:36:02.825Z"
  }
],
  "occupant_owner": {
  "occupant_name": null,
    "occupant_phone": null,
    "occupant_type": null,
    "owner_name": null,
    "owner_phone": null
},
  "open_houses": [
  {
    "id": 1542888663,
    "appointment_required_y_n": null,
    "listing_id": null,
    "listing_key": null,
    "listing_key_numeric": null,
    "modification_timestamp": null,
    "open_house_attended_by": null,
    "open_house_date": "2022-12-15T00:00:00.000Z",
    "open_house_end_time": "2022-12-15T07:20:00.000Z",
    "open_house_end_time_raw": "2022-12-15T02:20:00.000-05:00",
    "open_house_id": null,
    "open_house_key": null,
    "open_house_key_numeric": null,
    "open_house_remarks": null,
    "open_house_start_time": "2022-12-15T07:10:00.000Z",
    "open_house_start_time_raw": "2022-12-15T02:10:00.000-05:00",
    "open_house_status": null,
    "open_house_type": null,
    "original_entry_timestamp": null,
    "originating_system_id": null,
    "originating_system_key": null,
    "originating_system_name": null,
    "refreshments": null,
    "showing_agent_first_name": null,
    "showing_agent_key": null,
    "showing_agent_key_numeric": null,
    "showing_agent_last_name": null,
    "showing_agent_mls_id": null,
    "source_system_id": null,
    "source_system_key": null,
    "source_system_name": null,
    "virtual_open_house_details": null,
    "virtual_open_house_url": null,
    "created_at": "2021-11-15T22:47:41.913Z",
    "updated_at": "2021-12-03T16:16:33.902Z"
  },
  {
    "id": 1542888839,
    "appointment_required_y_n": null,
    "listing_id": null,
    "listing_key": null,
    "listing_key_numeric": null,
    "modification_timestamp": null,
    "open_house_attended_by": null,
    "open_house_date": "2022-12-16T00:00:00.000Z",
    "open_house_end_time": "2022-12-16T08:20:00.000Z",
    "open_house_end_time_raw": "2022-12-16T03:20:00.000-05:00",
    "open_house_id": null,
    "open_house_key": null,
    "open_house_key_numeric": null,
    "open_house_remarks": null,
    "open_house_start_time": "2022-12-16T08:15:00.000Z",
    "open_house_start_time_raw": "2022-12-16T03:15:00.000-05:00",
    "open_house_status": null,
    "open_house_type": null,
    "original_entry_timestamp": null,
    "originating_system_id": null,
    "originating_system_key": null,
    "originating_system_name": null,
    "refreshments": null,
    "showing_agent_first_name": null,
    "showing_agent_key": null,
    "showing_agent_key_numeric": null,
    "showing_agent_last_name": null,
    "showing_agent_mls_id": null,
    "source_system_id": null,
    "source_system_key": null,
    "source_system_name": null,
    "virtual_open_house_details": null,
    "virtual_open_house_url": null,
    "created_at": "2021-11-15T23:01:55.297Z",
    "updated_at": "2021-12-03T16:17:23.413Z"
  },
  {
    "id": 1542888840,
    "appointment_required_y_n": null,
    "listing_id": null,
    "listing_key": null,
    "listing_key_numeric": null,
    "modification_timestamp": null,
    "open_house_attended_by": null,
    "open_house_date": "2021-12-17T00:00:00.000Z",
    "open_house_end_time": "2021-12-17T09:25:00.000Z",
    "open_house_end_time_raw": "2021-12-17T04:25:00.000-05:00",
    "open_house_id": null,
    "open_house_key": null,
    "open_house_key_numeric": null,
    "open_house_remarks": null,
    "open_house_start_time": "2022-12-17T09:20:00.000Z",
    "open_house_start_time_raw": "2022-12-17T04:20:00.000-05:00",
    "open_house_status": null,
    "open_house_type": null,
    "original_entry_timestamp": null,
    "originating_system_id": null,
    "originating_system_key": null,
    "originating_system_name": null,
    "refreshments": null,
    "showing_agent_first_name": null,
    "showing_agent_key": null,
    "showing_agent_key_numeric": null,
    "showing_agent_last_name": null,
    "showing_agent_mls_id": null,
    "source_system_id": null,
    "source_system_key": null,
    "source_system_name": null,
    "virtual_open_house_details": null,
    "virtual_open_house_url": null,
    "created_at": "2021-11-15T23:01:55.304Z",
    "updated_at": "2021-12-03T16:17:23.415Z"
  },
  {
    "id": 1542888841,
    "appointment_required_y_n": null,
    "listing_id": null,
    "listing_key": null,
    "listing_key_numeric": null,
    "modification_timestamp": null,
    "open_house_attended_by": null,
    "open_house_date": "2021-11-20T00:00:00.000Z",
    "open_house_end_time": "2021-11-20T10:30:00.000Z",
    "open_house_end_time_raw": "2021-11-20T05:30:00.000-05:00",
    "open_house_id": null,
    "open_house_key": null,
    "open_house_key_numeric": null,
    "open_house_remarks": null,
    "open_house_start_time": "2022-11-05T10:24:00.000Z",
    "open_house_start_time_raw": "2022-11-20T05:24:00.000-05:00",
    "open_house_status": null,
    "open_house_type": null,
    "original_entry_timestamp": null,
    "originating_system_id": null,
    "originating_system_key": null,
    "originating_system_name": null,
    "refreshments": null,
    "showing_agent_first_name": null,
    "showing_agent_key": null,
    "showing_agent_key_numeric": null,
    "showing_agent_last_name": null,
    "showing_agent_mls_id": null,
    "source_system_id": null,
    "source_system_key": null,
    "source_system_name": null,
    "virtual_open_house_details": null,
    "virtual_open_house_url": null,
    "created_at": "2021-11-15T23:01:55.306Z",
    "updated_at": "2021-11-15T23:01:55.306Z"
  },
  {
    "id": 1542888841,
    "appointment_required_y_n": null,
    "listing_id": null,
    "listing_key": null,
    "listing_key_numeric": null,
    "modification_timestamp": null,
    "open_house_attended_by": null,
    "open_house_date": "2021-11-20T00:00:00.000Z",
    "open_house_end_time": "2021-11-20T10:30:00.000Z",
    "open_house_end_time_raw": "2021-11-20T05:30:00.000-05:00",
    "open_house_id": null,
    "open_house_key": null,
    "open_house_key_numeric": null,
    "open_house_remarks": null,
    "open_house_start_time": "2022-11-01T10:24:00.000Z",
    "open_house_start_time_raw": "2022-11-20T05:24:00.000-05:00",
    "open_house_status": null,
    "open_house_type": null,
    "original_entry_timestamp": null,
    "originating_system_id": null,
    "originating_system_key": null,
    "originating_system_name": null,
    "refreshments": null,
    "showing_agent_first_name": null,
    "showing_agent_key": null,
    "showing_agent_key_numeric": null,
    "showing_agent_last_name": null,
    "showing_agent_mls_id": null,
    "source_system_id": null,
    "source_system_key": null,
    "source_system_name": null,
    "virtual_open_house_details": null,
    "virtual_open_house_url": null,
    "created_at": "2021-11-15T23:01:55.306Z",
    "updated_at": "2021-11-15T23:01:55.306Z"
  },
  {
    "id": 1542888841,
    "appointment_required_y_n": null,
    "listing_id": null,
    "listing_key": null,
    "listing_key_numeric": null,
    "modification_timestamp": null,
    "open_house_attended_by": null,
    "open_house_date": "2021-11-20T00:00:00.000Z",
    "open_house_end_time": "2021-11-20T10:30:00.000Z",
    "open_house_end_time_raw": "2021-11-20T05:30:00.000-05:00",
    "open_house_id": null,
    "open_house_key": null,
    "open_house_key_numeric": null,
    "open_house_remarks": null,
    "open_house_start_time": "2022-11-02T10:24:00.000Z",
    "open_house_start_time_raw": "2022-11-20T05:24:00.000-05:00",
    "open_house_status": null,
    "open_house_type": null,
    "original_entry_timestamp": null,
    "originating_system_id": null,
    "originating_system_key": null,
    "originating_system_name": null,
    "refreshments": null,
    "showing_agent_first_name": null,
    "showing_agent_key": null,
    "showing_agent_key_numeric": null,
    "showing_agent_last_name": null,
    "showing_agent_mls_id": null,
    "source_system_id": null,
    "source_system_key": null,
    "source_system_name": null,
    "virtual_open_house_details": null,
    "virtual_open_house_url": null,
    "created_at": "2021-11-15T23:01:55.306Z",
    "updated_at": "2021-11-15T23:01:55.306Z"
  },
  {
    "id": 1542888841,
    "appointment_required_y_n": null,
    "listing_id": null,
    "listing_key": null,
    "listing_key_numeric": null,
    "modification_timestamp": null,
    "open_house_attended_by": null,
    "open_house_date": "2021-11-20T00:00:00.000Z",
    "open_house_end_time": "2021-11-20T10:30:00.000Z",
    "open_house_end_time_raw": "2021-11-20T05:30:00.000-05:00",
    "open_house_id": null,
    "open_house_key": null,
    "open_house_key_numeric": null,
    "open_house_remarks": null,
    "open_house_start_time": "2022-11-04T10:24:00.000Z",
    "open_house_start_time_raw": "2022-11-20T05:24:00.000-05:00",
    "open_house_status": null,
    "open_house_type": null,
    "original_entry_timestamp": null,
    "originating_system_id": null,
    "originating_system_key": null,
    "originating_system_name": null,
    "refreshments": null,
    "showing_agent_first_name": null,
    "showing_agent_key": null,
    "showing_agent_key_numeric": null,
    "showing_agent_last_name": null,
    "showing_agent_mls_id": null,
    "source_system_id": null,
    "source_system_key": null,
    "source_system_name": null,
    "virtual_open_house_details": null,
    "virtual_open_house_url": null,
    "created_at": "2021-11-15T23:01:55.306Z",
    "updated_at": "2021-11-15T23:01:55.306Z"
  },
  {
    "id": 1542888841,
    "appointment_required_y_n": null,
    "listing_id": null,
    "listing_key": null,
    "listing_key_numeric": null,
    "modification_timestamp": null,
    "open_house_attended_by": null,
    "open_house_date": "2021-11-20T00:00:00.000Z",
    "open_house_end_time": "2021-11-20T10:30:00.000Z",
    "open_house_end_time_raw": "2021-11-20T05:30:00.000-05:00",
    "open_house_id": null,
    "open_house_key": null,
    "open_house_key_numeric": null,
    "open_house_remarks": null,
    "open_house_start_time": "2022-11-03T10:00:00.000Z",
    "open_house_start_time_raw": "2022-11-20T05:24:00.000-05:00",
    "open_house_status": null,
    "open_house_type": null,
    "original_entry_timestamp": null,
    "originating_system_id": null,
    "originating_system_key": null,
    "originating_system_name": null,
    "refreshments": null,
    "showing_agent_first_name": null,
    "showing_agent_key": null,
    "showing_agent_key_numeric": null,
    "showing_agent_last_name": null,
    "showing_agent_mls_id": null,
    "source_system_id": null,
    "source_system_key": null,
    "source_system_name": null,
    "virtual_open_house_details": null,
    "virtual_open_house_url": null,
    "created_at": "2021-11-15T23:01:55.306Z",
    "updated_at": "2021-11-15T23:01:55.306Z"
  },
],
  "structure": {
  "above_grade_finished_area": "90000.0",
    "above_grade_finished_area_source": null,
    "above_grade_finished_area_units": "Square Feet",
    "accessibility_features": null,
    "architectural_style": "Style One",
    "attached_garage_y_n": true,
    "basement": null,
    "bathrooms": null,
    "bathrooms_full": 10,
    "bathrooms_half": 30,
    "bathrooms_one_quarter": null,
    "bathrooms_partial": 50,
    "bathrooms_three_quarter": 20,
    "bathrooms_total_integer": 60,
    "bedrooms_possible": null,
    "bedrooms_total": 10,
    "below_grade_finished_area": null,
    "below_grade_finished_area_source": null,
    "below_grade_finished_area_units": null,
    "body_type": null,
    "builder_model": null,
    "builder_name": null,
    "building_area_source": null,
    "building_area_total": null,
    "building_area_units": null,
    "building_features": null,
    "building_name": "Iansbuilding",
    "carport_spaces": null,
    "carport_y_n": null,
    "common_walls": null,
    "construction_materials": null,
    "cooling": null,
    "cooling_y_n": null,
    "covered_spaces": null,
    "direction_faces": "East",
    "doh_1": null,
    "doh_2": null,
    "doh_3": null,
    "door_features": null,
    "entry_level": null,
    "entry_location": null,
    "exterior_features": null,
    "fireplace_features": null,
    "fireplaces_total": null,
    "fireplace_y_n": null,
    "flooring": null,
    "foundation_area": null,
    "foundation_details": null,
    "garage_spaces": "40.0",
    "garage_y_n": null,
    "habitable_residence_y_n": null,
    "heating": null,
    "heating_y_n": null,
    "interior_features": null,
    "leasable_area": null,
    "leasable_area_units": null,
    "levels": null,
    "license_1": null,
    "license_2": null,
    "license_3": null,
    "living_area": "50000.0",
    "living_area_source": null,
    "living_area_units": "Square Feet",
    "main_level_bathrooms": null,
    "main_level_bedrooms": null,
    "make": null,
    "mobile_dim_units": null,
    "mobile_length": null,
    "mobile_width": null,
    "model": null,
    "new_construction": null,
    "new_construction_y_n": true,
    "open_parking_spaces": null,
    "open_parking_y_n": null,
    "other_structures": null,
    "parking_features": null,
    "parking_total": "50.0",
    "patio_and_porch_features": null,
    "primary_on_main_y_n": null,
    "property_attached_y_n": null,
    "property_condition": null,
    "roof": null,
    "rv_parking_dimensions": null,
    "serial_u": null,
    "serial_x": null,
    "serial_xx": null,
    "skirt": null,
    "stories": null,
    "stories_total": null,
    "structure_type": null,
    "window_features": null,
    "year_built_details": null,
    "year_built_effective": null,
    "year_built": 2009,
    "year_built_source": null,
    "performance": {
    "green_marketing": {
      "green_energy_efficient": null,
        "green_energy_generation": null,
        "green_indoor_air_quality": null,
        "green_location": null,
        "green_sustainability": null,
        "green_water_conservation": null,
        "walk_score": null
    }
  }
},
  "tax": {
    "additional_parcels_description": null,
    "additional_parcels_y_n": null,
    "parcel_number": null,
    "public_survey_range": null,
    "public_survey_section": null,
    "public_survey_township": null,
    "tax_annual_amount": null,
    "tax_assessed_value": null,
    "tax_block": null,
    "tax_book_number": null,
    "tax_legal_description": null,
    "tax_lot": null,
    "tax_map_number": null,
    "tax_other_annual_assessment_amount": null,
    "tax_parcel_letter": null,
    "tax_status_current": null,
    "tax_tract": null,
    "tax_year": null,
    "zoning_description": null,
    "zoning": null
},
  "utility": {
  "distance_to_bus_comments": null,
    "distance_to_bus_numeric": null,
    "distance_to_bus_units": null,
    "distance_to_electric_comments": null,
    "distance_to_electric_numeric": null,
    "distance_to_electric_units": null,
    "distance_to_freeway_comments": null,
    "distance_to_freeway_numeric": null,
    "distance_to_freeway_units": null,
    "distance_to_gas_comments": null,
    "distance_to_gas_numeric": null,
    "distance_to_gas_units": null,
    "distance_to_phone_service_comments": null,
    "distance_to_phone_service_numeric": null,
    "distance_to_phone_service_units": null,
    "distance_to_placeof_worship_comments": null,
    "distance_to_placeof_worship_numeric": null,
    "distance_to_placeof_worship_units": null,
    "distance_to_school_bus_comments": null,
    "distance_to_school_bus_numeric": null,
    "distance_to_school_bus_units": null,
    "distance_to_schools_comments": null,
    "distance_to_schools_numeric": null,
    "distance_to_schools_units": null,
    "distance_to_sewer_comments": null,
    "distance_to_sewer_numeric": null,
    "distance_to_sewer_units": null,
    "distance_to_shopping_comments": null,
    "distance_to_shopping_numeric": null,
    "distance_to_shopping_units": null,
    "distance_to_street_comments": null,
    "distance_to_street_numeric": null,
    "distance_to_street_units": null,
    "distance_to_water_comments": null,
    "distance_to_water_numeric": null,
    "distance_to_water_units": null,
    "electric": null,
    "electric_on_property_y_n": null,
    "irrigation_source": null,
    "irrigation_water_rights_acres": null,
    "irrigation_water_rights_y_n": null,
    "number_of_separate_electric_meters": null,
    "number_of_separate_gas_meters": null,
    "number_of_separate_water_meters": null,
    "sewer": null,
    "utilities": null,
    "water_source": null
},
  "raw_property": {
  "id": 295310144,
    "property_type": "Land",
    "property_sub_type": "Type 1",
    "property_universal_id": null,
    "dash_guid": null,
    "dash_deactivated_at": null,
    "source": "User",
    "created_at": "2021-09-20T23:16:45.322Z",
    "updated_at": "2022-02-04T14:58:26.062Z",
    "private": false,
    "hide_photos": false,
    "board_id": null,
    "property_id": null,
    "user_id": 1011665,
    "custom_fields": {},
  "characteristics": {
    "anchors_co_tenants": null,
      "community_features": null,
      "current_use": null,
      "development_status": null,
      "fencing": null,
      "frontage_length": null,
      "frontage_type": null,
      "furnished": null,
      "furnished_y_n": null,
      "horse_amenities": null,
      "horse_y_n": null,
      "land_lease_amount": null,
      "land_lease_amount_frequency": null,
      "land_lease_expiration_date": null,
      "land_lease_y_n": null,
      "laundry_features": null,
      "lease_term": "6 Months",
      "lot_dimensions_source": null,
      "lot_features": null,
      "lot_size_acres": null,
      "lot_size_area": "10.0",
      "lot_size_dimensions": null,
      "lot_size_source": null,
      "lot_size_square_feet": null,
      "lot_size_units": "Acres",
      "mobile_home_remains_y_n": null,
      "number_of_buildings": null,
      "number_of_lots": null,
      "number_of_pads": null,
      "number_of_units_in_community": null,
      "number_of_units_total": null,
      "park_manager_name": null,
      "park_manager_phone": null,
      "park_name": null,
      "pool_features": null,
      "pool_private_y_n": null,
      "possible_use": null,
      "road_frontage_type": null,
      "road_responsibility": null,
      "road_surface_type": null,
      "senior_community_y_n": null,
      "spa_features": null,
      "spa_y_n": null,
      "topography": null,
      "units_furnished": null,
      "view": "View 1",
      "view_y_n": null,
      "water_body_name": null,
      "waterfront_features": null,
      "waterfront_y_n": null
  },
  "meta": [],
    "board": null,
    "business": {
    "business_name": null,
      "business_type": null,
      "hours_days_of_operation_description": null,
      "hours_days_of_operation": null,
      "labor_information": null,
      "lease_amount": null,
      "lease_amount_frequency": null,
      "lease_assignable_y_n": null,
      "lease_expiration": null,
      "lease_renewal_option_y_n": null,
      "number_of_full_time_employees": null,
      "number_of_part_time_employees": null,
      "ownership_type": null,
      "seating_capacity": null,
      "special_licenses": null,
      "year_established": null,
      "years_current_owner": null
  },
  "equipment": {
    "appliances": null,
      "other_equipment": null,
      "security_features": null
  },
  "farming": {
    "crops_included_y_n": null,
      "cultivated_area": null,
      "farm_credit_service_incl_y_n": null,
      "farm_land_area_source": null,
      "farm_land_area_units": null,
      "grazing_permits_blm_y_n": null,
      "grazing_permits_forest_service_y_n": null,
      "grazing_permits_private_y_n": null,
      "pasture_area": null,
      "range_area": null,
      "vegetation": null,
      "wooded_area": null
  },
  "financial": {
    "cable_tv_expense": null,
      "cap_rate": null,
      "electric_expense": null,
      "existing_lease_type": null,
      "financial_data_source": null,
      "fuel_expense": null,
      "furniture_replacement_expense": null,
      "gardener_expense": null,
      "gross_income": null,
      "gross_scheduled_income": null,
      "income_includes": null,
      "insurance_expense": null,
      "licenses_expense": null,
      "maintenance_expense": null,
      "manager_expense": null,
      "net_operating_income": null,
      "new_taxes_expense": null,
      "number_of_units_leased": null,
      "number_of_units_mo_mo": null,
      "number_of_units_vacant": null,
      "operating_expense": null,
      "operating_expense_includes": null,
      "other_expense": null,
      "owner_pays": null,
      "pest_control_expense": null,
      "pool_expense": null,
      "professional_management_expense": null,
      "rent_control_y_n": null,
      "rent_includes": null,
      "security_deposit": null,
      "supplies_expense": null,
      "tenant_pays": null,
      "total_actual_rent": null,
      "trash_expense": null,
      "vacancy_allowance": null,
      "vacancy_allowance_rate": null,
      "water_sewer_expense": null,
      "workmans_compensation_expense": null
  },
  "hoa": {
    "association_amenities": null,
      "association_fee_2": null,
      "association_fee_2_frequency": null,
      "association_fee": null,
      "association_fee_frequency": null,
      "association_fee_includes": null,
      "association_name_2": null,
      "association_name": null,
      "association_phone_2": null,
      "association_phone": null,
      "association_y_n": null,
      "pets_allowed": null
  },
  "listing": {
    "copyright_notice": null,
      "disclaimer": null,
      "home_warranty_y_n": null,
      "lease_considered_y_n": null,
      "list_aor": null,
      "listing_agreement": null,
      "listing_id": null,
      "listing_key": null,
      "listing_key_numeric": null,
      "listing_service": null,
      "listing_type": "Type One",
      "mls_status": "Sold",
      "originating_system_id": null,
      "originating_system_key": null,
      "originating_system_name": null,
      "source_system_id": null,
      "source_system_key": null,
      "source_system_name": null,
      "standard_status": null,
      "agent_office": {
      "buyer_agent": {
        "user_id": null,
          "buyer_agent_aor": null,
          "buyer_agent_designation": null,
          "buyer_agent_direct_phone": null,
          "buyer_agent_email": null,
          "buyer_agent_fax": null,
          "buyer_agent_first_name": null,
          "buyer_agent_full_name": null,
          "buyer_agent_home_phone": null,
          "buyer_agent_key": null,
          "buyer_agent_key_numeric": null,
          "buyer_agent_last_name": null,
          "buyer_agent_middle_name": null,
          "buyer_agent_mls_id": null,
          "buyer_agent_mobile_phone": null,
          "buyer_agent_name_prefix": null,
          "buyer_agent_name_suffix": null,
          "buyer_agent_office_phone_ext": null,
          "buyer_agent_office_phone": null,
          "buyer_agent_pager": null,
          "buyer_agent_preferred_phone_ext": null,
          "buyer_agent_preferred_phone": null,
          "buyer_agent_state_license": null,
          "buyer_agent_toll_free_phone": null,
          "buyer_agent_url": null,
          "buyer_agent_voice_mail_ext": null,
          "buyer_agent_voice_mail": null
      },
      "buyer_office": {
        "buyer_office_aor": null,
          "buyer_office_email": null,
          "buyer_office_fax": null,
          "buyer_office_key": null,
          "buyer_office_key_numeric": null,
          "buyer_office_mls_id": null,
          "buyer_office_name": null,
          "buyer_office_phone_ext": null,
          "buyer_office_phone": null,
          "buyer_office_url": null,
          "office": null
      },
      "co_buyer_agent": {
        "user_id": null,
          "co_buyer_agent_aor": null,
          "co_buyer_agent_designation": null,
          "co_buyer_agent_direct_phone": null,
          "co_buyer_agent_email": null,
          "co_buyer_agent_fax": null,
          "co_buyer_agent_first_name": null,
          "co_buyer_agent_full_name": null,
          "co_buyer_agent_home_phone": null,
          "co_buyer_agent_key": null,
          "co_buyer_agent_key_numeric": null,
          "co_buyer_agent_last_name": null,
          "co_buyer_agent_middle_name": null,
          "co_buyer_agent_mls_id": null,
          "co_buyer_agent_mobile_phone": null,
          "co_buyer_agent_name_prefix": null,
          "co_buyer_agent_name_suffix": null,
          "co_buyer_agent_office_phone_ext": null,
          "co_buyer_agent_office_phone": null,
          "co_buyer_agent_pager": null,
          "co_buyer_agent_preferred_phone_ext": null,
          "co_buyer_agent_preferred_phone": null,
          "co_buyer_agent_state_license": null,
          "co_buyer_agent_toll_free_phone": null,
          "co_buyer_agent_url": null,
          "co_buyer_agent_voice_mail_ext": null,
          "co_buyer_agent_voice_mail": null
      },
      "co_buyer_agent2": {
        "user_id": null,
          "co_buyer_agent2_aor": null,
          "co_buyer_agent2_designation": null,
          "co_buyer_agent2_direct_phone": null,
          "co_buyer_agent2_email": null,
          "co_buyer_agent2_fax": null,
          "co_buyer_agent2_first_name": null,
          "co_buyer_agent2_full_name": null,
          "co_buyer_agent2_home_phone": null,
          "co_buyer_agent2_key": null,
          "co_buyer_agent2_key_numeric": null,
          "co_buyer_agent2_last_name": null,
          "co_buyer_agent2_middle_name": null,
          "co_buyer_agent2_mls_id": null,
          "co_buyer_agent2_mobile_phone": null,
          "co_buyer_agent2_name_prefix": null,
          "co_buyer_agent2_name_suffix": null,
          "co_buyer_agent2_office_phone_ext": null,
          "co_buyer_agent2_office_phone": null,
          "co_buyer_agent2_pager": null,
          "co_buyer_agent2_preferred_phone_ext": null,
          "co_buyer_agent2_preferred_phone": null,
          "co_buyer_agent2_state_license": null,
          "co_buyer_agent2_toll_free_phone": null,
          "co_buyer_agent2_url": null,
          "co_buyer_agent2_voice_mail_ext": null,
          "co_buyer_agent2_voice_mail": null
      },
      "co_buyer_agent3": {
        "user_id": null,
          "co_buyer_agent3_aor": null,
          "co_buyer_agent3_designation": null,
          "co_buyer_agent3_direct_phone": null,
          "co_buyer_agent3_email": null,
          "co_buyer_agent3_fax": null,
          "co_buyer_agent3_first_name": null,
          "co_buyer_agent3_full_name": null,
          "co_buyer_agent3_home_phone": null,
          "co_buyer_agent3_key": null,
          "co_buyer_agent3_key_numeric": null,
          "co_buyer_agent3_last_name": null,
          "co_buyer_agent3_middle_name": null,
          "co_buyer_agent3_mls_id": null,
          "co_buyer_agent3_mobile_phone": null,
          "co_buyer_agent3_name_prefix": null,
          "co_buyer_agent3_name_suffix": null,
          "co_buyer_agent3_office_phone_ext": null,
          "co_buyer_agent3_office_phone": null,
          "co_buyer_agent3_pager": null,
          "co_buyer_agent3_preferred_phone_ext": null,
          "co_buyer_agent3_preferred_phone": null,
          "co_buyer_agent3_state_license": null,
          "co_buyer_agent3_toll_free_phone": null,
          "co_buyer_agent3_url": null,
          "co_buyer_agent3_voice_mail_ext": null,
          "co_buyer_agent3_voice_mail": null
      },
      "co_buyer_agent4": {
        "user_id": null,
          "co_buyer_agent4_aor": null,
          "co_buyer_agent4_designation": null,
          "co_buyer_agent4_direct_phone": null,
          "co_buyer_agent4_email": null,
          "co_buyer_agent4_fax": null,
          "co_buyer_agent4_first_name": null,
          "co_buyer_agent4_full_name": null,
          "co_buyer_agent4_home_phone": null,
          "co_buyer_agent4_key": null,
          "co_buyer_agent4_key_numeric": null,
          "co_buyer_agent4_last_name": null,
          "co_buyer_agent4_middle_name": null,
          "co_buyer_agent4_mls_id": null,
          "co_buyer_agent4_mobile_phone": null,
          "co_buyer_agent4_name_prefix": null,
          "co_buyer_agent4_name_suffix": null,
          "co_buyer_agent4_office_phone_ext": null,
          "co_buyer_agent4_office_phone": null,
          "co_buyer_agent4_pager": null,
          "co_buyer_agent4_preferred_phone_ext": null,
          "co_buyer_agent4_preferred_phone": null,
          "co_buyer_agent4_state_license": null,
          "co_buyer_agent4_toll_free_phone": null,
          "co_buyer_agent4_url": null,
          "co_buyer_agent4_voice_mail_ext": null,
          "co_buyer_agent4_voice_mail": null
      },
      "co_buyer_agent5": {
        "user_id": null,
          "co_buyer_agent5_aor": null,
          "co_buyer_agent5_designation": null,
          "co_buyer_agent5_direct_phone": null,
          "co_buyer_agent5_email": null,
          "co_buyer_agent5_fax": null,
          "co_buyer_agent5_first_name": null,
          "co_buyer_agent5_full_name": null,
          "co_buyer_agent5_home_phone": null,
          "co_buyer_agent5_key": null,
          "co_buyer_agent5_key_numeric": null,
          "co_buyer_agent5_last_name": null,
          "co_buyer_agent5_middle_name": null,
          "co_buyer_agent5_mls_id": null,
          "co_buyer_agent5_mobile_phone": null,
          "co_buyer_agent5_name_prefix": null,
          "co_buyer_agent5_name_suffix": null,
          "co_buyer_agent5_office_phone_ext": null,
          "co_buyer_agent5_office_phone": null,
          "co_buyer_agent5_pager": null,
          "co_buyer_agent5_preferred_phone_ext": null,
          "co_buyer_agent5_preferred_phone": null,
          "co_buyer_agent5_state_license": null,
          "co_buyer_agent5_toll_free_phone": null,
          "co_buyer_agent5_url": null,
          "co_buyer_agent5_voice_mail_ext": null,
          "co_buyer_agent5_voice_mail": null
      },
      "co_buyer_office": {
        "co_buyer_office_aor": null,
          "co_buyer_office_email": null,
          "co_buyer_office_fax": null,
          "co_buyer_office_key": null,
          "co_buyer_office_key_numeric": null,
          "co_buyer_office_mls_id": null,
          "co_buyer_office_name": null,
          "co_buyer_office_phone_ext": null,
          "co_buyer_office_phone": null,
          "co_buyer_office_url": null,
          "office": null
      },
      "co_list_agent": {
        "user_id": 1011527,
          "co_list_agent_aor": null,
          "co_list_agent_designation": "Associate Broker, Broker, BPOR: Broker Price Opinion Resource, B.S. Real Estate, CAM: Certified Apartment Manager, CBR: Certified Buyer Representative, Commercial Sales/Leasing, CRB℠: Certified Real Estate Brokerage Manager, e-PRO, WPS: Waterfront Property Specialist, SRS: Seller Representative Specialist, SFR: Short Sales & Foreclosure Resource, SIOR: Society of Industrial and Office REALTORS, SRES: Seniors Real Estate Specialist",
          "co_list_agent_direct_phone": null,
          "co_list_agent_email": "ian.leon+user4@tribusgroup.com",
          "co_list_agent_fax": null,
          "co_list_agent_first_name": "User",
          "co_list_agent_full_name": null,
          "co_list_agent_home_phone": null,
          "co_list_agent_key": null,
          "co_list_agent_key_numeric": null,
          "co_list_agent_last_name": "Fo'ur",
          "co_list_agent_middle_name": null,
          "co_list_agent_mls_id": null,
          "co_list_agent_mobile_phone": null,
          "co_list_agent_name_prefix": null,
          "co_list_agent_name_suffix": null,
          "co_list_agent_office_phone_ext": null,
          "co_list_agent_office_phone": null,
          "co_list_agent_pager": null,
          "co_list_agent_preferred_phone_ext": null,
          "co_list_agent_preferred_phone": null,
          "co_list_agent_state_license": null,
          "co_list_agent_toll_free_phone": null,
          "co_list_agent_url": null,
          "co_list_agent_voice_mail_ext": null,
          "co_list_agent_voice_mail": null
      },
      "co_list_agent2": {
        "user_id": null,
          "co_list_agent2_aor": null,
          "co_list_agent2_designation": null,
          "co_list_agent2_direct_phone": null,
          "co_list_agent2_email": null,
          "co_list_agent2_fax": null,
          "co_list_agent2_first_name": null,
          "co_list_agent2_full_name": null,
          "co_list_agent2_home_phone": null,
          "co_list_agent2_key": null,
          "co_list_agent2_key_numeric": null,
          "co_list_agent2_last_name": null,
          "co_list_agent2_middle_name": null,
          "co_list_agent2_mls_id": null,
          "co_list_agent2_mobile_phone": null,
          "co_list_agent2_name_prefix": null,
          "co_list_agent2_name_suffix": null,
          "co_list_agent2_office_phone_ext": null,
          "co_list_agent2_office_phone": null,
          "co_list_agent2_pager": null,
          "co_list_agent2_preferred_phone_ext": null,
          "co_list_agent2_preferred_phone": null,
          "co_list_agent2_state_license": null,
          "co_list_agent2_toll_free_phone": null,
          "co_list_agent2_url": null,
          "co_list_agent2_voice_mail_ext": null,
          "co_list_agent2_voice_mail": null
      },
      "co_list_agent3": {
        "user_id": null,
          "co_list_agent3_aor": null,
          "co_list_agent3_designation": null,
          "co_list_agent3_direct_phone": null,
          "co_list_agent3_email": null,
          "co_list_agent3_fax": null,
          "co_list_agent3_first_name": null,
          "co_list_agent3_full_name": null,
          "co_list_agent3_home_phone": null,
          "co_list_agent3_key": null,
          "co_list_agent3_key_numeric": null,
          "co_list_agent3_last_name": null,
          "co_list_agent3_middle_name": null,
          "co_list_agent3_mls_id": null,
          "co_list_agent3_mobile_phone": null,
          "co_list_agent3_name_prefix": null,
          "co_list_agent3_name_suffix": null,
          "co_list_agent3_office_phone_ext": null,
          "co_list_agent3_office_phone": null,
          "co_list_agent3_pager": null,
          "co_list_agent3_preferred_phone_ext": null,
          "co_list_agent3_preferred_phone": null,
          "co_list_agent3_state_license": null,
          "co_list_agent3_toll_free_phone": null,
          "co_list_agent3_url": null,
          "co_list_agent3_voice_mail_ext": null,
          "co_list_agent3_voice_mail": null
      },
      "co_list_agent4": {
        "user_id": null,
          "co_list_agent4_aor": null,
          "co_list_agent4_designation": null,
          "co_list_agent4_direct_phone": null,
          "co_list_agent4_email": null,
          "co_list_agent4_fax": null,
          "co_list_agent4_first_name": null,
          "co_list_agent4_full_name": null,
          "co_list_agent4_home_phone": null,
          "co_list_agent4_key": null,
          "co_list_agent4_key_numeric": null,
          "co_list_agent4_last_name": null,
          "co_list_agent4_middle_name": null,
          "co_list_agent4_mls_id": null,
          "co_list_agent4_mobile_phone": null,
          "co_list_agent4_name_prefix": null,
          "co_list_agent4_name_suffix": null,
          "co_list_agent4_office_phone_ext": null,
          "co_list_agent4_office_phone": null,
          "co_list_agent4_pager": null,
          "co_list_agent4_preferred_phone_ext": null,
          "co_list_agent4_preferred_phone": null,
          "co_list_agent4_state_license": null,
          "co_list_agent4_toll_free_phone": null,
          "co_list_agent4_url": null,
          "co_list_agent4_voice_mail_ext": null,
          "co_list_agent4_voice_mail": null
      },
      "co_list_agent5": {
        "user_id": null,
          "co_list_agent5_aor": null,
          "co_list_agent5_designation": null,
          "co_list_agent5_direct_phone": null,
          "co_list_agent5_email": null,
          "co_list_agent5_fax": null,
          "co_list_agent5_first_name": null,
          "co_list_agent5_full_name": null,
          "co_list_agent5_home_phone": null,
          "co_list_agent5_key": null,
          "co_list_agent5_key_numeric": null,
          "co_list_agent5_last_name": null,
          "co_list_agent5_middle_name": null,
          "co_list_agent5_mls_id": null,
          "co_list_agent5_mobile_phone": null,
          "co_list_agent5_name_prefix": null,
          "co_list_agent5_name_suffix": null,
          "co_list_agent5_office_phone_ext": null,
          "co_list_agent5_office_phone": null,
          "co_list_agent5_pager": null,
          "co_list_agent5_preferred_phone_ext": null,
          "co_list_agent5_preferred_phone": null,
          "co_list_agent5_state_license": null,
          "co_list_agent5_toll_free_phone": null,
          "co_list_agent5_url": null,
          "co_list_agent5_voice_mail_ext": null,
          "co_list_agent5_voice_mail": null
      },
      "co_list_office": {
        "co_list_office_aor": null,
          "co_list_office_email": null,
          "co_list_office_fax": null,
          "co_list_office_key": null,
          "co_list_office_key_numeric": null,
          "co_list_office_mls_id": null,
          "co_list_office_name": null,
          "co_list_office_phone_ext": null,
          "co_list_office_phone": null,
          "co_list_office_url": null,
          "office": null
      },
      "co_relocation_agent": {
        "user_id": null,
          "co_relocation_agent_aor": null,
          "co_relocation_agent_designation": null,
          "co_relocation_agent_direct_phone": null,
          "co_relocation_agent_email": null,
          "co_relocation_agent_fax": null,
          "co_relocation_agent_first_name": null,
          "co_relocation_agent_full_name": null,
          "co_relocation_agent_home_phone": null,
          "co_relocation_agent_key": null,
          "co_relocation_agent_key_numeric": null,
          "co_relocation_agent_last_name": null,
          "co_relocation_agent_middle_name": null,
          "co_relocation_agent_mls_id": null,
          "co_relocation_agent_mobile_phone": null,
          "co_relocation_agent_name_prefix": null,
          "co_relocation_agent_name_suffix": null,
          "co_relocation_agent_office_phone_ext": null,
          "co_relocation_agent_office_phone": null,
          "co_relocation_agent_pager": null,
          "co_relocation_agent_preferred_phone_ext": null,
          "co_relocation_agent_preferred_phone": null,
          "co_relocation_agent_state_license": null,
          "co_relocation_agent_toll_free_phone": null,
          "co_relocation_agent_url": null,
          "co_relocation_agent_voice_mail_ext": null,
          "co_relocation_agent_voice_mail": null
      },
      "co_relocation_agent2": {
        "user_id": null,
          "co_relocation_agent2_aor": null,
          "co_relocation_agent2_designation": null,
          "co_relocation_agent2_direct_phone": null,
          "co_relocation_agent2_email": null,
          "co_relocation_agent2_fax": null,
          "co_relocation_agent2_first_name": null,
          "co_relocation_agent2_full_name": null,
          "co_relocation_agent2_home_phone": null,
          "co_relocation_agent2_key": null,
          "co_relocation_agent2_key_numeric": null,
          "co_relocation_agent2_last_name": null,
          "co_relocation_agent2_middle_name": null,
          "co_relocation_agent2_mls_id": null,
          "co_relocation_agent2_mobile_phone": null,
          "co_relocation_agent2_name_prefix": null,
          "co_relocation_agent2_name_suffix": null,
          "co_relocation_agent2_office_phone_ext": null,
          "co_relocation_agent2_office_phone": null,
          "co_relocation_agent2_pager": null,
          "co_relocation_agent2_preferred_phone_ext": null,
          "co_relocation_agent2_preferred_phone": null,
          "co_relocation_agent2_state_license": null,
          "co_relocation_agent2_toll_free_phone": null,
          "co_relocation_agent2_url": null,
          "co_relocation_agent2_voice_mail_ext": null,
          "co_relocation_agent2_voice_mail": null
      },
      "co_relocation_agent3": {
        "user_id": null,
          "co_relocation_agent3_aor": null,
          "co_relocation_agent3_designation": null,
          "co_relocation_agent3_direct_phone": null,
          "co_relocation_agent3_email": null,
          "co_relocation_agent3_fax": null,
          "co_relocation_agent3_first_name": null,
          "co_relocation_agent3_full_name": null,
          "co_relocation_agent3_home_phone": null,
          "co_relocation_agent3_key": null,
          "co_relocation_agent3_key_numeric": null,
          "co_relocation_agent3_last_name": null,
          "co_relocation_agent3_middle_name": null,
          "co_relocation_agent3_mls_id": null,
          "co_relocation_agent3_mobile_phone": null,
          "co_relocation_agent3_name_prefix": null,
          "co_relocation_agent3_name_suffix": null,
          "co_relocation_agent3_office_phone_ext": null,
          "co_relocation_agent3_office_phone": null,
          "co_relocation_agent3_pager": null,
          "co_relocation_agent3_preferred_phone_ext": null,
          "co_relocation_agent3_preferred_phone": null,
          "co_relocation_agent3_state_license": null,
          "co_relocation_agent3_toll_free_phone": null,
          "co_relocation_agent3_url": null,
          "co_relocation_agent3_voice_mail_ext": null,
          "co_relocation_agent3_voice_mail": null
      },
      "co_relocation_agent4": {
        "user_id": null,
          "co_relocation_agent4_aor": null,
          "co_relocation_agent4_designation": null,
          "co_relocation_agent4_direct_phone": null,
          "co_relocation_agent4_email": null,
          "co_relocation_agent4_fax": null,
          "co_relocation_agent4_first_name": null,
          "co_relocation_agent4_full_name": null,
          "co_relocation_agent4_home_phone": null,
          "co_relocation_agent4_key": null,
          "co_relocation_agent4_key_numeric": null,
          "co_relocation_agent4_last_name": null,
          "co_relocation_agent4_middle_name": null,
          "co_relocation_agent4_mls_id": null,
          "co_relocation_agent4_mobile_phone": null,
          "co_relocation_agent4_name_prefix": null,
          "co_relocation_agent4_name_suffix": null,
          "co_relocation_agent4_office_phone_ext": null,
          "co_relocation_agent4_office_phone": null,
          "co_relocation_agent4_pager": null,
          "co_relocation_agent4_preferred_phone_ext": null,
          "co_relocation_agent4_preferred_phone": null,
          "co_relocation_agent4_state_license": null,
          "co_relocation_agent4_toll_free_phone": null,
          "co_relocation_agent4_url": null,
          "co_relocation_agent4_voice_mail_ext": null,
          "co_relocation_agent4_voice_mail": null
      },
      "co_relocation_agent5": {
        "user_id": null,
          "co_relocation_agent5_aor": null,
          "co_relocation_agent5_designation": null,
          "co_relocation_agent5_direct_phone": null,
          "co_relocation_agent5_email": null,
          "co_relocation_agent5_fax": null,
          "co_relocation_agent5_first_name": null,
          "co_relocation_agent5_full_name": null,
          "co_relocation_agent5_home_phone": null,
          "co_relocation_agent5_key": null,
          "co_relocation_agent5_key_numeric": null,
          "co_relocation_agent5_last_name": null,
          "co_relocation_agent5_middle_name": null,
          "co_relocation_agent5_mls_id": null,
          "co_relocation_agent5_mobile_phone": null,
          "co_relocation_agent5_name_prefix": null,
          "co_relocation_agent5_name_suffix": null,
          "co_relocation_agent5_office_phone_ext": null,
          "co_relocation_agent5_office_phone": null,
          "co_relocation_agent5_pager": null,
          "co_relocation_agent5_preferred_phone_ext": null,
          "co_relocation_agent5_preferred_phone": null,
          "co_relocation_agent5_state_license": null,
          "co_relocation_agent5_toll_free_phone": null,
          "co_relocation_agent5_url": null,
          "co_relocation_agent5_voice_mail_ext": null,
          "co_relocation_agent5_voice_mail": null
      },
      "co_showing_agent": {
        "user_id": null,
          "co_showing_agent_aor": null,
          "co_showing_agent_designation": null,
          "co_showing_agent_direct_phone": null,
          "co_showing_agent_email": null,
          "co_showing_agent_fax": null,
          "co_showing_agent_first_name": null,
          "co_showing_agent_full_name": null,
          "co_showing_agent_home_phone": null,
          "co_showing_agent_key": null,
          "co_showing_agent_key_numeric": null,
          "co_showing_agent_last_name": null,
          "co_showing_agent_middle_name": null,
          "co_showing_agent_mls_id": null,
          "co_showing_agent_mobile_phone": null,
          "co_showing_agent_name_prefix": null,
          "co_showing_agent_name_suffix": null,
          "co_showing_agent_office_phone_ext": null,
          "co_showing_agent_office_phone": null,
          "co_showing_agent_pager": null,
          "co_showing_agent_preferred_phone_ext": null,
          "co_showing_agent_preferred_phone": null,
          "co_showing_agent_state_license": null,
          "co_showing_agent_toll_free_phone": null,
          "co_showing_agent_url": null,
          "co_showing_agent_voice_mail_ext": null,
          "co_showing_agent_voice_mail": null
      },
      "co_showing_agent2": {
        "user_id": null,
          "co_showing_agent2_aor": null,
          "co_showing_agent2_designation": null,
          "co_showing_agent2_direct_phone": null,
          "co_showing_agent2_email": null,
          "co_showing_agent2_fax": null,
          "co_showing_agent2_first_name": null,
          "co_showing_agent2_full_name": null,
          "co_showing_agent2_home_phone": null,
          "co_showing_agent2_key": null,
          "co_showing_agent2_key_numeric": null,
          "co_showing_agent2_last_name": null,
          "co_showing_agent2_middle_name": null,
          "co_showing_agent2_mls_id": null,
          "co_showing_agent2_mobile_phone": null,
          "co_showing_agent2_name_prefix": null,
          "co_showing_agent2_name_suffix": null,
          "co_showing_agent2_office_phone_ext": null,
          "co_showing_agent2_office_phone": null,
          "co_showing_agent2_pager": null,
          "co_showing_agent2_preferred_phone_ext": null,
          "co_showing_agent2_preferred_phone": null,
          "co_showing_agent2_state_license": null,
          "co_showing_agent2_toll_free_phone": null,
          "co_showing_agent2_url": null,
          "co_showing_agent2_voice_mail_ext": null,
          "co_showing_agent2_voice_mail": null
      },
      "co_showing_agent3": {
        "user_id": null,
          "co_showing_agent3_aor": null,
          "co_showing_agent3_designation": null,
          "co_showing_agent3_direct_phone": null,
          "co_showing_agent3_email": null,
          "co_showing_agent3_fax": null,
          "co_showing_agent3_first_name": null,
          "co_showing_agent3_full_name": null,
          "co_showing_agent3_home_phone": null,
          "co_showing_agent3_key": null,
          "co_showing_agent3_key_numeric": null,
          "co_showing_agent3_last_name": null,
          "co_showing_agent3_middle_name": null,
          "co_showing_agent3_mls_id": null,
          "co_showing_agent3_mobile_phone": null,
          "co_showing_agent3_name_prefix": null,
          "co_showing_agent3_name_suffix": null,
          "co_showing_agent3_office_phone_ext": null,
          "co_showing_agent3_office_phone": null,
          "co_showing_agent3_pager": null,
          "co_showing_agent3_preferred_phone_ext": null,
          "co_showing_agent3_preferred_phone": null,
          "co_showing_agent3_state_license": null,
          "co_showing_agent3_toll_free_phone": null,
          "co_showing_agent3_url": null,
          "co_showing_agent3_voice_mail_ext": null,
          "co_showing_agent3_voice_mail": null
      },
      "co_showing_agent4": {
        "user_id": null,
          "co_showing_agent4_aor": null,
          "co_showing_agent4_designation": null,
          "co_showing_agent4_direct_phone": null,
          "co_showing_agent4_email": null,
          "co_showing_agent4_fax": null,
          "co_showing_agent4_first_name": null,
          "co_showing_agent4_full_name": null,
          "co_showing_agent4_home_phone": null,
          "co_showing_agent4_key": null,
          "co_showing_agent4_key_numeric": null,
          "co_showing_agent4_last_name": null,
          "co_showing_agent4_middle_name": null,
          "co_showing_agent4_mls_id": null,
          "co_showing_agent4_mobile_phone": null,
          "co_showing_agent4_name_prefix": null,
          "co_showing_agent4_name_suffix": null,
          "co_showing_agent4_office_phone_ext": null,
          "co_showing_agent4_office_phone": null,
          "co_showing_agent4_pager": null,
          "co_showing_agent4_preferred_phone_ext": null,
          "co_showing_agent4_preferred_phone": null,
          "co_showing_agent4_state_license": null,
          "co_showing_agent4_toll_free_phone": null,
          "co_showing_agent4_url": null,
          "co_showing_agent4_voice_mail_ext": null,
          "co_showing_agent4_voice_mail": null
      },
      "co_showing_agent5": {
        "user_id": null,
          "co_showing_agent5_aor": null,
          "co_showing_agent5_designation": null,
          "co_showing_agent5_direct_phone": null,
          "co_showing_agent5_email": null,
          "co_showing_agent5_fax": null,
          "co_showing_agent5_first_name": null,
          "co_showing_agent5_full_name": null,
          "co_showing_agent5_home_phone": null,
          "co_showing_agent5_key": null,
          "co_showing_agent5_key_numeric": null,
          "co_showing_agent5_last_name": null,
          "co_showing_agent5_middle_name": null,
          "co_showing_agent5_mls_id": null,
          "co_showing_agent5_mobile_phone": null,
          "co_showing_agent5_name_prefix": null,
          "co_showing_agent5_name_suffix": null,
          "co_showing_agent5_office_phone_ext": null,
          "co_showing_agent5_office_phone": null,
          "co_showing_agent5_pager": null,
          "co_showing_agent5_preferred_phone_ext": null,
          "co_showing_agent5_preferred_phone": null,
          "co_showing_agent5_state_license": null,
          "co_showing_agent5_toll_free_phone": null,
          "co_showing_agent5_url": null,
          "co_showing_agent5_voice_mail_ext": null,
          "co_showing_agent5_voice_mail": null
      },
      "list_agent": {
        "user_id": 1011525,
          "list_agent_aor": null,
          "list_agent_designation": "",
          "list_agent_direct_phone": "4444444444",
          "list_agent_email": "ian.leon+user2@tribusgroup.com",
          "list_agent_fax": null,
          "list_agent_first_name": "User",
          "list_agent_full_name": "User Two",
          "list_agent_home_phone": null,
          "list_agent_key": null,
          "list_agent_key_numeric": null,
          "list_agent_last_name": "Two",
          "list_agent_middle_name": null,
          "list_agent_mls_id": null,
          "list_agent_mobile_phone": null,
          "list_agent_name_prefix": null,
          "list_agent_name_suffix": null,
          "list_agent_office_phone_ext": null,
          "list_agent_office_phone": null,
          "list_agent_pager": null,
          "list_agent_preferred_phone_ext": null,
          "list_agent_preferred_phone": "4444444444",
          "list_agent_state_license": null,
          "list_agent_toll_free_phone": null,
          "list_agent_url": null,
          "list_agent_voice_mail_ext": null,
          "list_agent_voice_mail": null
      },
      "list_office": {
        "list_office_aor": null,
          "list_office_email": null,
          "list_office_fax": null,
          "list_office_key": null,
          "list_office_key_numeric": null,
          "list_office_mls_id": null,
          "list_office_name": null,
          "list_office_phone_ext": null,
          "list_office_phone": null,
          "list_office_url": null,
          "office": null
      },
      "relocation_agent": {
        "user_id": null,
          "relocation_agent_aor": null,
          "relocation_agent_designation": null,
          "relocation_agent_direct_phone": null,
          "relocation_agent_email": null,
          "relocation_agent_fax": null,
          "relocation_agent_first_name": null,
          "relocation_agent_full_name": null,
          "relocation_agent_home_phone": null,
          "relocation_agent_key": null,
          "relocation_agent_key_numeric": null,
          "relocation_agent_last_name": null,
          "relocation_agent_middle_name": null,
          "relocation_agent_mls_id": null,
          "relocation_agent_mobile_phone": null,
          "relocation_agent_name_prefix": null,
          "relocation_agent_name_suffix": null,
          "relocation_agent_office_phone_ext": null,
          "relocation_agent_office_phone": null,
          "relocation_agent_pager": null,
          "relocation_agent_preferred_phone_ext": null,
          "relocation_agent_preferred_phone": null,
          "relocation_agent_state_license": null,
          "relocation_agent_toll_free_phone": null,
          "relocation_agent_url": null,
          "relocation_agent_voice_mail_ext": null,
          "relocation_agent_voice_mail": null
      },
      "showing_agent": {
        "user_id": null,
          "showing_agent_aor": null,
          "showing_agent_designation": null,
          "showing_agent_direct_phone": null,
          "showing_agent_email": null,
          "showing_agent_fax": null,
          "showing_agent_first_name": null,
          "showing_agent_full_name": null,
          "showing_agent_home_phone": null,
          "showing_agent_key": null,
          "showing_agent_key_numeric": null,
          "showing_agent_last_name": null,
          "showing_agent_middle_name": null,
          "showing_agent_mls_id": null,
          "showing_agent_mobile_phone": null,
          "showing_agent_name_prefix": null,
          "showing_agent_name_suffix": null,
          "showing_agent_office_phone_ext": null,
          "showing_agent_office_phone": null,
          "showing_agent_pager": null,
          "showing_agent_preferred_phone_ext": null,
          "showing_agent_preferred_phone": null,
          "showing_agent_state_license": null,
          "showing_agent_toll_free_phone": null,
          "showing_agent_url": null,
          "showing_agent_voice_mail_ext": null,
          "showing_agent_voice_mail": null
      },
      "team": {
        "buyer_team_key": null,
          "buyer_team_key_numeric": null,
          "buyer_team_name": null,
          "list_team_key": null,
          "list_team_key_numeric": null,
          "list_team_name": null
      }
    },
    "closing": {
      "availability_date": null,
        "buyer_financing": null,
        "concessions_amount": null,
        "concessions_comments": null,
        "concessions": null,
        "contingency": null,
        "possession": null
    },
    "compensation": {
      "buyer_agency_compensation": null,
        "buyer_agency_compensation_type": null,
        "dual_variable_compensation_y_n": null,
        "lease_renewal_compensation": null,
        "sub_agency_compensation": null,
        "sub_agency_compensation_type": null,
        "transaction_broker_compensation": null,
        "transaction_broker_compensation_type": null
    },
    "contract": {
      "current_financing": null,
        "disclosures": null,
        "exclusions": null,
        "inclusions": null,
        "listing_terms": null,
        "ownership": null,
        "special_listing_conditions": null,
        "common_interest": null,
        "foreclosure_y_n": false,
        "short_sale_y_n": false
    },
    "dates": {
      "cancelation_date": null,
        "close_date": null,
        "contingent_date": null,
        "contract_status_change_date": null,
        "cumulative_days_on_market": null,
        "days_on_market": null,
        "expiration_date": null,
        "listing_contract_date": null,
        "major_change_timestamp": null,
        "major_change_type": null,
        "modification_timestamp": "2022-02-04T14:58:25.491Z",
        "off_market_date": null,
        "off_market_timestamp": null,
        "on_market_date": null,
        "on_market_timestamp": null,
        "original_entry_timestamp": "2021-09-20T23:16:45.081Z",
        "pending_timestamp": null,
        "price_change_timestamp": null,
        "purchase_contract_date": null,
        "status_change_timestamp": null,
        "total_days_on_market": null,
        "withdrawn_date": null
    },
    "marketing": {
      "internet_address_display_y_n": null,
        "internet_automated_valuation_display_y_n": null,
        "internet_consumer_comment_y_n": null,
        "internet_entire_listing_display_y_n": true,
        "sign_on_property_y_n": null,
        "single_property_website_url": "https://spw.tst/",
        "single_property_website_y_n": true,
        "syndicate_to": null,
        "syndicate_y_n": false,
        "virtual_tour_url_branded": null,
        "virtual_tour_url_unbranded": null,
        "vow_y_n": null,
        "send_email": false
    },
    "media": {
      "documents_available": null,
        "documents_change_timestamp": null,
        "documents_count": null,
        "photos_change_timestamp": null,
        "photos_count": null,
        "videos_change_timestamp": null,
        "videos_count": null
    },
    "mls_status_snapshots": [
      {
        "modification_timestamp": "2022-02-04T14:58:26.053Z",
        "mls_status": "Sold"
      }
    ],
      "price": {
      "close_price": null,
        "list_price": "10000000.0",
        "list_price_low": null,
        "original_list_price": null,
        "previous_list_price": null,
        "list_price_snapshots": [
        {
          "modification_timestamp": "2021-11-30T17:18:57.102Z",
          "list_price": 10000000
        }
      ]
    },
    "remarks": {
      "excerpt": "",
        "headline": null,
        "private_office_remarks": null,
        "private_remarks": null,
        "public_remarks": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Porta lorem mollis aliquam ut porttitor leo a diam sollicitudin. Elementum curabitur vitae nunc sed velit dignissim sodales. Elementum curabitur vitae nunc sed velit dignissim sodales. Pharetra et ultrices neque ornare aenean euismod elementum nisi. Libero enim sed faucibus turpis in. Elit duis tristique sollicitudin nibh sit amet commodo nulla facilisi. Lectus magna fringilla urna porttitor rhoncus dolor. Cum sociis natoque penatibus et magnis dis. Donec pretium vulputate sapien nec sagittis aliquam malesuada bibendum arcu. <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/5qap5aO4i9A\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>",
        "publication_remarks": null,
        "publication_remarks_approved_y_n": false,
        "syndication_remarks": null
    },
    "showing": {
      "access_code": null,
        "lock_box_location": null,
        "lock_box_serial_number": null,
        "lock_box_type": null,
        "showing_advance_notice": null,
        "showing_attended_y_n": null,
        "showing_contact_name": null,
        "showing_contact_phone_ext": null,
        "showing_contact_phone": null,
        "showing_contact_type": null,
        "showing_days": null,
        "showing_instructions": null,
        "showing_requirements": null,
        "showing_start_time": null,
        "showing_end_time": null
    }
  },
  "location": {
    "address": {
      "address_slug": "181-nw-97th-ave-515-miami-fl-33172",
        "carrier_route": null,
        "city": "Miami",
        "country": null,
        "county_or_parish": "Ianscounty",
        "postal_city": null,
        "postal_code": "33172",
        "postal_code_plus_4": null,
        "state_or_province": "FL",
        "street_additional_info": null,
        "street_dir_prefix": null,
        "street_dir_suffix": null,
        "street_name": "181 NW 97th Ave",
        "street_number": null,
        "street_number_numeric": null,
        "street_suffix": null,
        "street_suffix_modifier": null,
        "township": null,
        "unit_number": "515",
        "unparsed_address": null
    },
    "area": {
      "city_region": null,
        "continent_region": null,
        "country_region": null,
        "mls_area_major": "Iansarea",
        "mls_area_minor": "Ianssubarea",
        "state_region": null,
        "subdivision_name": "Iansneighborhood"
    },
    "gis": {
      "cross_street": null,
        "directions": null,
        "elevation": null,
        "elevation_units": null,
        "latitude": null,
        "longitude": null,
        "map_coordinate": null,
        "map_coordinate_source": null,
        "map_url": null
    },
    "school": {
      "elementary_school_district": "e",
        "elementary_school": null,
        "high_school_district": "h",
        "high_school": null,
        "middle_or_junior_school_district": "m",
        "middle_or_junior_school": null
    }
  },
  "media": [
    {
      "id": 2367286983,
      "media_key": null,
      "media_status": "Active",
      "modification_timestamp": null,
      "media_type": null,
      "media_category": "Photo",
      "image_size_description": "Thumb",
      "order": 1,
      "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/4699542d-043a-481f-81d1-806ac10655c2.thumb.png",
      "short_description": null,
      "long_description": null,
      "changed_by_member_id": null,
      "changed_by_member_key": null,
      "changed_by_member_key_numeric": null,
      "class_name": null,
      "image_height": 350,
      "image_of": null,
      "image_width": 331,
      "media_html": null,
      "media_key_numeric": null,
      "media_modification_timestamp": null,
      "media_object_id": null,
      "originating_system_id": null,
      "originating_system_media_key": null,
      "originating_system_name": null,
      "permission": null,
      "preferred_photo_y_n": null,
      "resource_record_id": null,
      "resource_record_key_numeric": null,
      "source_system_id": null,
      "source_system_media_key": null,
      "source_system_name": null,
      "created_at": "2022-01-19T16:36:02.770Z",
      "updated_at": "2022-01-19T16:36:02.770Z"
    },
    {
      "id": 2367286987,
      "media_key": null,
      "media_status": "Active",
      "modification_timestamp": null,
      "media_type": null,
      "media_category": "Photo",
      "image_size_description": "Largest",
      "order": 1,
      "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/4699542d-043a-481f-81d1-806ac10655c2.png",
      "short_description": null,
      "long_description": null,
      "changed_by_member_id": null,
      "changed_by_member_key": null,
      "changed_by_member_key_numeric": null,
      "class_name": null,
      "image_height": 1360,
      "image_of": null,
      "image_width": 1288,
      "media_html": null,
      "media_key_numeric": null,
      "media_modification_timestamp": null,
      "media_object_id": null,
      "originating_system_id": null,
      "originating_system_media_key": null,
      "originating_system_name": null,
      "permission": null,
      "preferred_photo_y_n": null,
      "resource_record_id": null,
      "resource_record_key_numeric": null,
      "source_system_id": null,
      "source_system_media_key": null,
      "source_system_name": null,
      "created_at": "2022-01-19T16:36:02.786Z",
      "updated_at": "2022-01-19T16:36:02.786Z"
    },
    {
      "id": 2367286988,
      "media_key": null,
      "media_status": "Active",
      "modification_timestamp": null,
      "media_type": null,
      "media_category": "Photo",
      "image_size_description": "Thumb",
      "order": 2,
      "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/7a1ded91-f6f6-4fd2-947d-d2be6fb87335.thumb.png",
      "short_description": null,
      "long_description": null,
      "changed_by_member_id": null,
      "changed_by_member_key": null,
      "changed_by_member_key_numeric": null,
      "class_name": null,
      "image_height": 313,
      "image_of": null,
      "image_width": 350,
      "media_html": null,
      "media_key_numeric": null,
      "media_modification_timestamp": null,
      "media_object_id": null,
      "originating_system_id": null,
      "originating_system_media_key": null,
      "originating_system_name": null,
      "permission": null,
      "preferred_photo_y_n": null,
      "resource_record_id": null,
      "resource_record_key_numeric": null,
      "source_system_id": null,
      "source_system_media_key": null,
      "source_system_name": null,
      "created_at": "2022-01-19T16:36:02.792Z",
      "updated_at": "2022-01-19T16:36:02.792Z"
    },
    {
      "id": 2367286989,
      "media_key": null,
      "media_status": "Active",
      "modification_timestamp": null,
      "media_type": null,
      "media_category": "Photo",
      "image_size_description": "Largest",
      "order": 2,
      "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/7a1ded91-f6f6-4fd2-947d-d2be6fb87335.png",
      "short_description": null,
      "long_description": null,
      "changed_by_member_id": null,
      "changed_by_member_key": null,
      "changed_by_member_key_numeric": null,
      "class_name": null,
      "image_height": 1392,
      "image_of": null,
      "image_width": 1558,
      "media_html": null,
      "media_key_numeric": null,
      "media_modification_timestamp": null,
      "media_object_id": null,
      "originating_system_id": null,
      "originating_system_media_key": null,
      "originating_system_name": null,
      "permission": null,
      "preferred_photo_y_n": null,
      "resource_record_id": null,
      "resource_record_key_numeric": null,
      "source_system_id": null,
      "source_system_media_key": null,
      "source_system_name": null,
      "created_at": "2022-01-19T16:36:02.796Z",
      "updated_at": "2022-01-19T16:36:02.796Z"
    },
    {
      "id": 2367286990,
      "media_key": null,
      "media_status": "Active",
      "modification_timestamp": null,
      "media_type": null,
      "media_category": "Photo",
      "image_size_description": "Thumb",
      "order": 3,
      "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/267cdd33-24ad-400d-af1d-dc8228c34186.thumb.png",
      "short_description": null,
      "long_description": null,
      "changed_by_member_id": null,
      "changed_by_member_key": null,
      "changed_by_member_key_numeric": null,
      "class_name": null,
      "image_height": 350,
      "image_of": null,
      "image_width": 350,
      "media_html": null,
      "media_key_numeric": null,
      "media_modification_timestamp": null,
      "media_object_id": null,
      "originating_system_id": null,
      "originating_system_media_key": null,
      "originating_system_name": null,
      "permission": null,
      "preferred_photo_y_n": null,
      "resource_record_id": null,
      "resource_record_key_numeric": null,
      "source_system_id": null,
      "source_system_media_key": null,
      "source_system_name": null,
      "created_at": "2022-01-19T16:36:02.800Z",
      "updated_at": "2022-01-19T16:36:02.800Z"
    },
    {
      "id": 2367286991,
      "media_key": null,
      "media_status": "Active",
      "modification_timestamp": null,
      "media_type": null,
      "media_category": "Photo",
      "image_size_description": "Largest",
      "order": 3,
      "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/267cdd33-24ad-400d-af1d-dc8228c34186.png",
      "short_description": null,
      "long_description": null,
      "changed_by_member_id": null,
      "changed_by_member_key": null,
      "changed_by_member_key_numeric": null,
      "class_name": null,
      "image_height": 1100,
      "image_of": null,
      "image_width": 1100,
      "media_html": null,
      "media_key_numeric": null,
      "media_modification_timestamp": null,
      "media_object_id": null,
      "originating_system_id": null,
      "originating_system_media_key": null,
      "originating_system_name": null,
      "permission": null,
      "preferred_photo_y_n": null,
      "resource_record_id": null,
      "resource_record_key_numeric": null,
      "source_system_id": null,
      "source_system_media_key": null,
      "source_system_name": null,
      "created_at": "2022-01-19T16:36:02.804Z",
      "updated_at": "2022-01-19T16:36:02.804Z"
    },
    {
      "id": 2367286992,
      "media_key": null,
      "media_status": "Active",
      "modification_timestamp": null,
      "media_type": null,
      "media_category": "Photo",
      "image_size_description": "Thumb",
      "order": 4,
      "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/b70ba3e2-ed24-4c1c-8524-439cf45f37b7.thumb.png",
      "short_description": null,
      "long_description": null,
      "changed_by_member_id": null,
      "changed_by_member_key": null,
      "changed_by_member_key_numeric": null,
      "class_name": null,
      "image_height": 330,
      "image_of": null,
      "image_width": 350,
      "media_html": null,
      "media_key_numeric": null,
      "media_modification_timestamp": null,
      "media_object_id": null,
      "originating_system_id": null,
      "originating_system_media_key": null,
      "originating_system_name": null,
      "permission": null,
      "preferred_photo_y_n": null,
      "resource_record_id": null,
      "resource_record_key_numeric": null,
      "source_system_id": null,
      "source_system_media_key": null,
      "source_system_name": null,
      "created_at": "2022-01-19T16:36:02.809Z",
      "updated_at": "2022-01-19T16:36:02.809Z"
    },
    {
      "id": 2367286993,
      "media_key": null,
      "media_status": "Active",
      "modification_timestamp": null,
      "media_type": null,
      "media_category": "Photo",
      "image_size_description": "Largest",
      "order": 4,
      "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/b70ba3e2-ed24-4c1c-8524-439cf45f37b7.png",
      "short_description": null,
      "long_description": null,
      "changed_by_member_id": null,
      "changed_by_member_key": null,
      "changed_by_member_key_numeric": null,
      "class_name": null,
      "image_height": 1278,
      "image_of": null,
      "image_width": 1356,
      "media_html": null,
      "media_key_numeric": null,
      "media_modification_timestamp": null,
      "media_object_id": null,
      "originating_system_id": null,
      "originating_system_media_key": null,
      "originating_system_name": null,
      "permission": null,
      "preferred_photo_y_n": null,
      "resource_record_id": null,
      "resource_record_key_numeric": null,
      "source_system_id": null,
      "source_system_media_key": null,
      "source_system_name": null,
      "created_at": "2022-01-19T16:36:02.814Z",
      "updated_at": "2022-01-19T16:36:02.814Z"
    },
    {
      "id": 2367286994,
      "media_key": null,
      "media_status": "Active",
      "modification_timestamp": null,
      "media_type": null,
      "media_category": "Photo",
      "image_size_description": "Thumb",
      "order": 5,
      "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/4b5aabca-03ca-4068-87ed-228d39da6b7a.thumb.png",
      "short_description": null,
      "long_description": null,
      "changed_by_member_id": null,
      "changed_by_member_key": null,
      "changed_by_member_key_numeric": null,
      "class_name": null,
      "image_height": 350,
      "image_of": null,
      "image_width": 344,
      "media_html": null,
      "media_key_numeric": null,
      "media_modification_timestamp": null,
      "media_object_id": null,
      "originating_system_id": null,
      "originating_system_media_key": null,
      "originating_system_name": null,
      "permission": null,
      "preferred_photo_y_n": null,
      "resource_record_id": null,
      "resource_record_key_numeric": null,
      "source_system_id": null,
      "source_system_media_key": null,
      "source_system_name": null,
      "created_at": "2022-01-19T16:36:02.819Z",
      "updated_at": "2022-01-19T16:36:02.819Z"
    },
    {
      "id": 2367286995,
      "media_key": null,
      "media_status": "Active",
      "modification_timestamp": null,
      "media_type": null,
      "media_category": "Photo",
      "image_size_description": "Largest",
      "order": 5,
      "media_url": "https://storage.mytribus.com/32ef472a-f7d6-4482-b377-f36c5739ed61/files/4b5aabca-03ca-4068-87ed-228d39da6b7a.png",
      "short_description": null,
      "long_description": null,
      "changed_by_member_id": null,
      "changed_by_member_key": null,
      "changed_by_member_key_numeric": null,
      "class_name": null,
      "image_height": 1470,
      "image_of": null,
      "image_width": 1446,
      "media_html": null,
      "media_key_numeric": null,
      "media_modification_timestamp": null,
      "media_object_id": null,
      "originating_system_id": null,
      "originating_system_media_key": null,
      "originating_system_name": null,
      "permission": null,
      "preferred_photo_y_n": null,
      "resource_record_id": null,
      "resource_record_key_numeric": null,
      "source_system_id": null,
      "source_system_media_key": null,
      "source_system_name": null,
      "created_at": "2022-01-19T16:36:02.825Z",
      "updated_at": "2022-01-19T16:36:02.825Z"
    }
  ],
    "occupant_owner": {
    "occupant_name": null,
      "occupant_phone": null,
      "occupant_type": null,
      "owner_name": null,
      "owner_phone": null
  },
  "open_houses": [
    {
      "id": 1542888663,
      "appointment_required_y_n": null,
      "listing_id": null,
      "listing_key": null,
      "listing_key_numeric": null,
      "modification_timestamp": null,
      "open_house_attended_by": null,
      "open_house_date": "2021-12-15T00:00:00.000Z",
      "open_house_end_time": "2021-12-15T07:20:00.000Z",
      "open_house_end_time_raw": "2021-12-15T02:20:00.000-05:00",
      "open_house_id": null,
      "open_house_key": null,
      "open_house_key_numeric": null,
      "open_house_remarks": null,
      "open_house_start_time": "2021-12-15T07:10:00.000Z",
      "open_house_start_time_raw": "2021-12-15T02:10:00.000-05:00",
      "open_house_status": null,
      "open_house_type": null,
      "original_entry_timestamp": null,
      "originating_system_id": null,
      "originating_system_key": null,
      "originating_system_name": null,
      "refreshments": null,
      "showing_agent_first_name": null,
      "showing_agent_key": null,
      "showing_agent_key_numeric": null,
      "showing_agent_last_name": null,
      "showing_agent_mls_id": null,
      "source_system_id": null,
      "source_system_key": null,
      "source_system_name": null,
      "virtual_open_house_details": null,
      "virtual_open_house_url": null,
      "created_at": "2021-11-15T22:47:41.913Z",
      "updated_at": "2021-12-03T16:16:33.902Z"
    },
    {
      "id": 1542888839,
      "appointment_required_y_n": null,
      "listing_id": null,
      "listing_key": null,
      "listing_key_numeric": null,
      "modification_timestamp": null,
      "open_house_attended_by": null,
      "open_house_date": "2021-12-16T00:00:00.000Z",
      "open_house_end_time": "2021-12-16T08:20:00.000Z",
      "open_house_end_time_raw": "2021-12-16T03:20:00.000-05:00",
      "open_house_id": null,
      "open_house_key": null,
      "open_house_key_numeric": null,
      "open_house_remarks": null,
      "open_house_start_time": "2021-12-16T08:15:00.000Z",
      "open_house_start_time_raw": "2021-12-16T03:15:00.000-05:00",
      "open_house_status": null,
      "open_house_type": null,
      "original_entry_timestamp": null,
      "originating_system_id": null,
      "originating_system_key": null,
      "originating_system_name": null,
      "refreshments": null,
      "showing_agent_first_name": null,
      "showing_agent_key": null,
      "showing_agent_key_numeric": null,
      "showing_agent_last_name": null,
      "showing_agent_mls_id": null,
      "source_system_id": null,
      "source_system_key": null,
      "source_system_name": null,
      "virtual_open_house_details": null,
      "virtual_open_house_url": null,
      "created_at": "2021-11-15T23:01:55.297Z",
      "updated_at": "2021-12-03T16:17:23.413Z"
    },
    {
      "id": 1542888840,
      "appointment_required_y_n": null,
      "listing_id": null,
      "listing_key": null,
      "listing_key_numeric": null,
      "modification_timestamp": null,
      "open_house_attended_by": null,
      "open_house_date": "2021-12-17T00:00:00.000Z",
      "open_house_end_time": "2021-12-17T09:25:00.000Z",
      "open_house_end_time_raw": "2021-12-17T04:25:00.000-05:00",
      "open_house_id": null,
      "open_house_key": null,
      "open_house_key_numeric": null,
      "open_house_remarks": null,
      "open_house_start_time": "2021-12-17T09:20:00.000Z",
      "open_house_start_time_raw": "2021-12-17T04:20:00.000-05:00",
      "open_house_status": null,
      "open_house_type": null,
      "original_entry_timestamp": null,
      "originating_system_id": null,
      "originating_system_key": null,
      "originating_system_name": null,
      "refreshments": null,
      "showing_agent_first_name": null,
      "showing_agent_key": null,
      "showing_agent_key_numeric": null,
      "showing_agent_last_name": null,
      "showing_agent_mls_id": null,
      "source_system_id": null,
      "source_system_key": null,
      "source_system_name": null,
      "virtual_open_house_details": null,
      "virtual_open_house_url": null,
      "created_at": "2021-11-15T23:01:55.304Z",
      "updated_at": "2021-12-03T16:17:23.415Z"
    },
    {
      "id": 1542888841,
      "appointment_required_y_n": null,
      "listing_id": null,
      "listing_key": null,
      "listing_key_numeric": null,
      "modification_timestamp": null,
      "open_house_attended_by": null,
      "open_house_date": "2021-11-20T00:00:00.000Z",
      "open_house_end_time": "2021-11-20T10:30:00.000Z",
      "open_house_end_time_raw": "2021-11-20T05:30:00.000-05:00",
      "open_house_id": null,
      "open_house_key": null,
      "open_house_key_numeric": null,
      "open_house_remarks": null,
      "open_house_start_time": "2021-11-20T10:24:00.000Z",
      "open_house_start_time_raw": "2021-11-20T05:24:00.000-05:00",
      "open_house_status": null,
      "open_house_type": null,
      "original_entry_timestamp": null,
      "originating_system_id": null,
      "originating_system_key": null,
      "originating_system_name": null,
      "refreshments": null,
      "showing_agent_first_name": null,
      "showing_agent_key": null,
      "showing_agent_key_numeric": null,
      "showing_agent_last_name": null,
      "showing_agent_mls_id": null,
      "source_system_id": null,
      "source_system_key": null,
      "source_system_name": null,
      "virtual_open_house_details": null,
      "virtual_open_house_url": null,
      "created_at": "2021-11-15T23:01:55.306Z",
      "updated_at": "2021-11-15T23:01:55.306Z"
    }
  ],
    "structure": {
    "above_grade_finished_area": "90000.0",
      "above_grade_finished_area_source": null,
      "above_grade_finished_area_units": "Square Feet",
      "accessibility_features": null,
      "architectural_style": "Style One",
      "attached_garage_y_n": true,
      "basement": null,
      "bathrooms": null,
      "bathrooms_full": 10,
      "bathrooms_half": 30,
      "bathrooms_one_quarter": null,
      "bathrooms_partial": 50,
      "bathrooms_three_quarter": 20,
      "bathrooms_total_integer": 60,
      "bedrooms_possible": null,
      "bedrooms_total": 10,
      "below_grade_finished_area": null,
      "below_grade_finished_area_source": null,
      "below_grade_finished_area_units": null,
      "body_type": null,
      "builder_model": null,
      "builder_name": null,
      "building_area_source": null,
      "building_area_total": null,
      "building_area_units": null,
      "building_features": null,
      "building_name": "Iansbuilding",
      "carport_spaces": null,
      "carport_y_n": null,
      "common_walls": null,
      "construction_materials": null,
      "cooling": null,
      "cooling_y_n": null,
      "covered_spaces": null,
      "direction_faces": "East",
      "doh_1": null,
      "doh_2": null,
      "doh_3": null,
      "door_features": null,
      "entry_level": null,
      "entry_location": null,
      "exterior_features": null,
      "fireplace_features": null,
      "fireplaces_total": null,
      "fireplace_y_n": null,
      "flooring": null,
      "foundation_area": null,
      "foundation_details": null,
      "garage_spaces": "40.0",
      "garage_y_n": null,
      "habitable_residence_y_n": null,
      "heating": null,
      "heating_y_n": null,
      "interior_features": null,
      "leasable_area": null,
      "leasable_area_units": null,
      "levels": null,
      "license_1": null,
      "license_2": null,
      "license_3": null,
      "living_area": "50000.0",
      "living_area_source": null,
      "living_area_units": "Square Feet",
      "main_level_bathrooms": null,
      "main_level_bedrooms": null,
      "make": null,
      "mobile_dim_units": null,
      "mobile_length": null,
      "mobile_width": null,
      "model": null,
      "new_construction": null,
      "new_construction_y_n": true,
      "open_parking_spaces": null,
      "open_parking_y_n": null,
      "other_structures": null,
      "parking_features": null,
      "parking_total": "50.0",
      "patio_and_porch_features": null,
      "primary_on_main_y_n": null,
      "property_attached_y_n": null,
      "property_condition": null,
      "roof": null,
      "rv_parking_dimensions": null,
      "serial_u": null,
      "serial_x": null,
      "serial_xx": null,
      "skirt": null,
      "stories": null,
      "stories_total": null,
      "structure_type": null,
      "window_features": null,
      "year_built_details": null,
      "year_built_effective": null,
      "year_built": 2009,
      "year_built_source": null,
      "performance": {
      "green_marketing": {
        "green_energy_efficient": null,
          "green_energy_generation": null,
          "green_indoor_air_quality": null,
          "green_location": null,
          "green_sustainability": null,
          "green_water_conservation": null,
          "walk_score": null
      }
    }
  },
  "tax": {
    "additional_parcels_description": null,
      "additional_parcels_y_n": null,
      "parcel_number": null,
      "public_survey_range": null,
      "public_survey_section": null,
      "public_survey_township": null,
      "tax_annual_amount": null,
      "tax_assessed_value": null,
      "tax_block": null,
      "tax_book_number": null,
      "tax_legal_description": null,
      "tax_lot": null,
      "tax_map_number": null,
      "tax_other_annual_assessment_amount": null,
      "tax_parcel_letter": null,
      "tax_status_current": null,
      "tax_tract": null,
      "tax_year": null,
      "zoning_description": null,
      "zoning": null
  },
  "utility": {
    "distance_to_bus_comments": null,
      "distance_to_bus_numeric": null,
      "distance_to_bus_units": null,
      "distance_to_electric_comments": null,
      "distance_to_electric_numeric": null,
      "distance_to_electric_units": null,
      "distance_to_freeway_comments": null,
      "distance_to_freeway_numeric": null,
      "distance_to_freeway_units": null,
      "distance_to_gas_comments": null,
      "distance_to_gas_numeric": null,
      "distance_to_gas_units": null,
      "distance_to_phone_service_comments": null,
      "distance_to_phone_service_numeric": null,
      "distance_to_phone_service_units": null,
      "distance_to_placeof_worship_comments": null,
      "distance_to_placeof_worship_numeric": null,
      "distance_to_placeof_worship_units": null,
      "distance_to_school_bus_comments": null,
      "distance_to_school_bus_numeric": null,
      "distance_to_school_bus_units": null,
      "distance_to_schools_comments": null,
      "distance_to_schools_numeric": null,
      "distance_to_schools_units": null,
      "distance_to_sewer_comments": null,
      "distance_to_sewer_numeric": null,
      "distance_to_sewer_units": null,
      "distance_to_shopping_comments": null,
      "distance_to_shopping_numeric": null,
      "distance_to_shopping_units": null,
      "distance_to_street_comments": null,
      "distance_to_street_numeric": null,
      "distance_to_street_units": null,
      "distance_to_water_comments": null,
      "distance_to_water_numeric": null,
      "distance_to_water_units": null,
      "electric": null,
      "electric_on_property_y_n": null,
      "irrigation_source": null,
      "irrigation_water_rights_acres": null,
      "irrigation_water_rights_y_n": null,
      "number_of_separate_electric_meters": null,
      "number_of_separate_gas_meters": null,
      "number_of_separate_water_meters": null,
      "sewer": null,
      "utilities": null,
      "water_source": null
  },
  "property_ratings": []
},
  "property_ratings": []
}
